import { api } from './baseApi';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  EmailAddress: any;
  JSON: any;
  JSONArray: any;
  JSONObject: any;
  PhoneNumber: any;
  Time: any;
  UUID: any;
};

export type AclRole = {
  __typename?: 'AclRole';
  id?: Maybe<Scalars['UUID']>;
  key?: Maybe<Scalars['String']>;
  lvl?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum AclRoleKey {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  Manager = 'MANAGER',
  MonitoringCenter = 'MONITORING_CENTER',
  Nurse = 'NURSE',
  SurveillanceCenter = 'SURVEILLANCE_CENTER',
  Therapist = 'THERAPIST'
}

export type AclRoleResult = {
  __typename?: 'AclRoleResult';
  data?: Maybe<Array<Maybe<AclRole>>>;
  meta?: Maybe<PageInfo>;
};

export type Action = {
  __typename?: 'Action';
  extra?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type ActivateUserSubscriptionByRedeemCode = {
  admin?: InputMaybe<Scalars['String']>;
  redeemCode: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  accommodationZone?: Maybe<Scalars['String']>;
  apartmentNumber?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['EmailAddress']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentNumber?: Maybe<Scalars['String']>;
  descriptiveNumber?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  formattedFullAddress?: Maybe<Scalars['String']>;
  formattedShortAddress?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  governName?: Maybe<Scalars['String']>;
  governType?: Maybe<Scalars['String']>;
  guideNumber?: Maybe<Scalars['String']>;
  houseType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identificationNumber?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  kilometer?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  manzana?: Maybe<Scalars['String']>;
  parish?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
  taxIdentificationNumber?: Maybe<Scalars['String']>;
  type?: Maybe<AddressType>;
  ubigeo?: Maybe<Scalars['String']>;
  zoneName?: Maybe<Scalars['String']>;
  zoneType?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  accommodationZone?: InputMaybe<Scalars['String']>;
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  descriptiveNumber?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  formattedFullAddress?: InputMaybe<Scalars['String']>;
  formattedShortAddress?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  governName?: InputMaybe<Scalars['String']>;
  governType?: InputMaybe<Scalars['String']>;
  guideNumber?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<Scalars['String']>;
  kilometer?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<Scalars['String']>;
  manzana?: InputMaybe<Scalars['String']>;
  parish?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  shortAddress?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  streetType?: InputMaybe<Scalars['String']>;
  ubigeo?: InputMaybe<Scalars['String']>;
  zoneName?: InputMaybe<Scalars['String']>;
  zoneType?: InputMaybe<Scalars['String']>;
};

export enum AddressType {
  Billing = 'BILLING',
  Contact = 'CONTACT'
}

export type AuditLog = {
  __typename?: 'AuditLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  targetEntityId?: Maybe<Scalars['String']>;
  targetEntityType?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AuditLogsResult = {
  __typename?: 'AuditLogsResult';
  data?: Maybe<Array<Maybe<AuditLog>>>;
  meta?: Maybe<PageInfo>;
};

export type AvailableDoctor = {
  __typename?: 'AvailableDoctor';
  city?: Maybe<Scalars['String']>;
  clkId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
};

export type AvailableDoctorsResult = {
  __typename?: 'AvailableDoctorsResult';
  data?: Maybe<Array<Maybe<AvailableDoctor>>>;
  meta?: Maybe<PageInfo>;
};

export type Badge = {
  __typename?: 'Badge';
  backgroundColor?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BioScanHistoriesResult = {
  __typename?: 'BioScanHistoriesResult';
  data?: Maybe<Array<Maybe<BioScanHistory>>>;
  meta?: Maybe<PageInfo>;
};

export type BioScanHistory = {
  __typename?: 'BioScanHistory';
  age?: Maybe<Scalars['String']>;
  breathingRateConfidence?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  heartRateConfidence?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['UUID']>;
  items?: Maybe<Array<Maybe<HealthDataItem>>>;
  weight?: Maybe<Scalars['String']>;
};

export type BulkUserHealthCategoryPermissionInput = {
  items?: InputMaybe<Array<InputMaybe<UserHealthCategoryPermissionInput>>>;
};

export type Calendar = {
  __typename?: 'Calendar';
  id: Scalars['UUID'];
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type CancelDrMaxReservationInput = {
  reservationId: Scalars['String'];
};

export type CancelDrMaxReservationResult = {
  __typename?: 'CancelDrMaxReservationResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Case = {
  __typename?: 'Case';
  caseEntries?: Maybe<Array<Maybe<CaseEntry>>>;
  caseStatus?: Maybe<Scalars['JSONObject']>;
  caseStatusValue?: Maybe<CaseStatus>;
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  child?: Maybe<User>;
  childId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  contactSpecialist?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  descriptionExtra?: Maybe<Scalars['JSONObject']>;
  diagnosis?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  isAssigned?: Maybe<Scalars['Boolean']>;
  isChatActive?: Maybe<Scalars['Boolean']>;
  isImmediate?: Maybe<Scalars['JSONObject']>;
  isMeddi?: Maybe<Scalars['Boolean']>;
  isMyCase?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  lastCaseEntry?: Maybe<CaseEntry>;
  lastNote?: Maybe<Note>;
  medicalReport?: Maybe<MedicalReport>;
  medicalReports?: Maybe<Array<Maybe<MedicalReport>>>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  patient?: Maybe<User>;
  patientDescription?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['UUID']>;
  patientParent?: Maybe<User>;
  paymentMethod?: Maybe<Scalars['String']>;
  priority?: Maybe<TermItem>;
  priorityId?: Maybe<Scalars['UUID']>;
  reassignedFrom?: Maybe<WorkplaceMember>;
  solveTo?: Maybe<Scalars['DateTime']>;
  solved?: Maybe<Scalars['Boolean']>;
  solvedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  titleShort?: Maybe<Scalars['String']>;
  totalUnreadCaseEntries?: Maybe<Scalars['Int']>;
  transportMethod?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibleAt?: Maybe<Scalars['DateTime']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type CaseMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export type CaseContact = {
  __typename?: 'CaseContact';
  iconUrl?: Maybe<Scalars['String']>;
  textRow1?: Maybe<Scalars['String']>;
  textRow2?: Maybe<Scalars['String']>;
  textRow3?: Maybe<Scalars['String']>;
  type?: Maybe<CaseContactType>;
  userId?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['String']>;
  workplaceMemberId?: Maybe<Scalars['String']>;
  workplaceMemberUserRelation?: Maybe<UserRelation>;
};


export type CaseContactWorkplaceMemberUserRelationArgs = {
  type?: InputMaybe<UserRelationType>;
};

export enum CaseContactType {
  Workplace = 'WORKPLACE',
  WorkplaceMember = 'WORKPLACE_MEMBER'
}

export type CaseContactsResult = {
  __typename?: 'CaseContactsResult';
  data?: Maybe<Array<Maybe<CaseContact>>>;
  meta?: Maybe<PageInfo>;
};

export enum CaseCreateDay {
  Before_1 = 'BEFORE_1',
  Before_3 = 'BEFORE_3',
  Before_7 = 'BEFORE_7',
  DateRange = 'DATE_RANGE'
}

export type CaseDoctor = {
  __typename?: 'CaseDoctor';
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  userRelation?: Maybe<UserRelation>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type CaseDoctorsResult = {
  __typename?: 'CaseDoctorsResult';
  data?: Maybe<Array<Maybe<CaseDoctor>>>;
  meta?: Maybe<PageInfo>;
};

export type CaseEntriesResult = {
  __typename?: 'CaseEntriesResult';
  data?: Maybe<Array<Maybe<CaseEntry>>>;
  meta?: Maybe<PageInfo>;
};

export type CaseEntry = {
  __typename?: 'CaseEntry';
  avResult?: Maybe<Scalars['String']>;
  case?: Maybe<Case>;
  caseEntryMembers?: Maybe<Array<Maybe<CaseEntryMember>>>;
  caseId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSONObject']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  inDocumentation?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  sender?: Maybe<User>;
  senderId?: Maybe<Scalars['UUID']>;
  thumb?: Maybe<Scalars['Boolean']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type CaseEntryMember = {
  __typename?: 'CaseEntryMember';
  caseEntry?: Maybe<CaseEntry>;
  caseEntryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  seen?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum CaseSolvedMonth {
  Before_1 = 'BEFORE_1',
  Before_3 = 'BEFORE_3'
}

export enum CaseStatus {
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

export type CaseType = {
  __typename?: 'CaseType';
  canBookOnSite?: Maybe<Scalars['Boolean']>;
  canBookOnline?: Maybe<Scalars['Boolean']>;
  canOrderImmediate?: Maybe<Scalars['Boolean']>;
  caseTypeItems?: Maybe<Array<Maybe<CaseTypeItem>>>;
  categoryTypeId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  eventInterval?: Maybe<Scalars['Int']>;
  hiddenForPatient?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isSystem?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  labelKey?: Maybe<Scalars['String']>;
  notificationBook?: Maybe<Scalars['Boolean']>;
  notificationCase?: Maybe<Scalars['Boolean']>;
  parentCaseTypeId?: Maybe<Scalars['UUID']>;
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['UUID']>;
  rank?: Maybe<Scalars['Int']>;
  rootCaseType?: Maybe<CaseType>;
  type?: Maybe<Scalars['String']>;
};

export type CaseTypeItem = {
  __typename?: 'CaseTypeItem';
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  parentCaseTypeItemId?: Maybe<Scalars['UUID']>;
  position?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  settings?: Maybe<Scalars['JSONObject']>;
  subtype?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum CaseTypeType {
  CaseType = 'CASE_TYPE',
  Folder = 'FOLDER'
}

export type CasesResult = {
  __typename?: 'CasesResult';
  data?: Maybe<Array<Maybe<Case>>>;
  meta?: Maybe<PageInfo>;
};

export type Certificate = {
  __typename?: 'Certificate';
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type CertificatesResult = {
  __typename?: 'CertificatesResult';
  data?: Maybe<Array<Maybe<Certificate>>>;
  meta?: Maybe<PageInfo>;
};

export type ChargeStatus = {
  __typename?: 'ChargeStatus';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ChargeSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  userSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  conversationMembers?: Maybe<Array<Maybe<ConversationMember>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  lastMessage?: Maybe<Message>;
  messages?: Maybe<Array<Maybe<Message>>>;
  myUnreadMessages?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  singleRecipient?: Maybe<ConversationMember>;
  totalRecipients?: Maybe<Scalars['Int']>;
  type?: Maybe<ConversationType>;
};


export type ConversationConversationMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ConversationMessagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export enum ConversationFolderEnum {
  Inbox = 'INBOX',
  Sent = 'SENT'
}

export type ConversationMember = {
  __typename?: 'ConversationMember';
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type ConversationMemberResult = {
  __typename?: 'ConversationMemberResult';
  data?: Maybe<Array<Maybe<ConversationMember>>>;
  meta?: Maybe<PageInfo>;
};

export enum ConversationType {
  HealthPlan = 'HEALTH_PLAN',
  Normal = 'NORMAL',
  Notification = 'NOTIFICATION',
  WorkflowChatbot = 'WORKFLOW_CHATBOT'
}

export type ConversationsResult = {
  __typename?: 'ConversationsResult';
  data?: Maybe<Array<Maybe<Conversation>>>;
  meta?: Maybe<PageInfo>;
};

export enum CreateCaseTarget {
  Workplace = 'WORKPLACE',
  WorkplaceMember = 'WORKPLACE_MEMBER'
}

export type CreateDrMaxPrescriptionReservationInput = {
  drmaxPickupPlaceId: Scalars['UUID'];
  prescriptionId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};

export type CreateEventInput = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  eventMembers?: InputMaybe<Array<InputMaybe<CreateEventMemberInput>>>;
  type: EventType;
};

export type CreateEventMemberInput = {
  user?: InputMaybe<CreateEventMemberUserInput>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateEventMemberUserInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']>;
  contactPhoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  firstName?: InputMaybe<Scalars['String']>;
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateGroupInput = {
  name: Scalars['String'];
};

export type CreateHealthPlanInput = {
  active: Scalars['Boolean'];
  code: Scalars['String'];
  initialQuestionnaireCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateHealthPlanUserFromDataInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  healthPlanId: Scalars['UUID'];
  ingestion?: InputMaybe<Scalars['JSONArray']>;
  questionnaire?: InputMaybe<Scalars['JSONObject']>;
  userId: Scalars['UUID'];
};

export type CreateHealthPlanUserInput = {
  healthPlanId: Scalars['UUID'];
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

export type CreateHealthPlanWorkplaceInput = {
  healthPlanId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type CreateInsuranceReportInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  diagnosis?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  extra?: InputMaybe<Scalars['JSON']>;
  insuranceId: Scalars['UUID'];
  operationId: Scalars['UUID'];
  patientId: Scalars['UUID'];
  points?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateLaboratoryInput = {
  address?: InputMaybe<AddressInput>;
  code: Scalars['String'];
  icl?: InputMaybe<Scalars['String']>;
  ico?: InputMaybe<Scalars['String']>;
  icp?: InputMaybe<Scalars['String']>;
  icz?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateLaboratoryWizardInput = {
  laboratoryId: Scalars['UUID'];
  type?: InputMaybe<LaboratoryWizardType>;
  wizardId: Scalars['UUID'];
};

export type CreateNoteInput = {
  caseId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  text: Scalars['String'];
};

export type CreateOperationReportInput = {
  code: Scalars['String'];
  extra?: InputMaybe<Scalars['JSON']>;
  insuranceId: Scalars['UUID'];
  ncziCode: Scalars['String'];
  points: Scalars['Int'];
  title: Scalars['String'];
  workplaceId: Scalars['UUID'];
};

export type CreateOrUpdateQuestionnaireResultMemberInput = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  questionnaireResultId: Scalars['UUID'];
  seen?: InputMaybe<Scalars['Boolean']>;
};

export type CreatePriceInput = {
  currency?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Decimal']>;
  priceWithVat?: InputMaybe<Scalars['Decimal']>;
  vatRate?: InputMaybe<Scalars['Float']>;
};

export type CreateProfileInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']>;
  contactPhoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  firstName?: InputMaybe<Scalars['String']>;
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
  salutationAfter?: InputMaybe<Scalars['String']>;
  salutationBefore?: InputMaybe<Scalars['String']>;
};

export type CreateRatingInput = {
  caseId?: InputMaybe<Scalars['UUID']>;
  stars?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<RatingType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type CreateSubscriptionGroup = {
  key: Scalars['String'];
};

export type CreateSubscriptionInput = {
  buyable?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  descriptionShort?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<CreateSubscriptionItemInput>>>;
  name: Scalars['String'];
  nameAdmin?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['Int']>;
  periods?: InputMaybe<Array<InputMaybe<CreateSubscriptionPeriodInput>>>;
  redeemCodeRequired?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<ThemeEnum>;
};

export type CreateSubscriptionItemInput = {
  extra?: InputMaybe<Scalars['JSONObject']>;
  type: SubscriptionItemType;
};

export type CreateSubscriptionPeriodInput = {
  period?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<CreatePriceInput>;
  type: SubscriptionPeriodType;
  value?: InputMaybe<Scalars['String']>;
};

export type CreateSubscriptionRedeemCodeInput = {
  code: Scalars['String'];
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['UUID']>;
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type CreateTokenInput = {
  type: TokenType;
};

export type CreateUserInput = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<CreateProfileInput>;
};

export type CreateUserSubscriptionMemberInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId: Scalars['UUID'];
};

export type CreateWizardResultInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  wizardId: Scalars['UUID'];
  wizardResultItems?: InputMaybe<Array<CreateWizardResultItemInput>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateWizardResultItemInput = {
  key: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateWorkplaceMemberAbsenceInput = {
  allowContactInAbsence?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  fullday?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
  workplaceMemberIds: Array<InputMaybe<Scalars['UUID']>>;
};

export type CreateWorkplacePresetInput = {
  memberType: WorkplacePresetMemberType;
  name: Scalars['String'];
  type: WorkplacePresetType;
};

export type DashboardLayoutItem = {
  __typename?: 'DashboardLayoutItem';
  background?: Maybe<Scalars['JSONObject']>;
  badge?: Maybe<Scalars['JSONObject']>;
  children?: Maybe<Array<Maybe<DashboardLayoutItem>>>;
  extra?: Maybe<Scalars['JSONObject']>;
  settings?: Maybe<Scalars['JSONObject']>;
  template?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  titleParts?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

export type DashboardTile = {
  __typename?: 'DashboardTile';
  action?: Maybe<Action>;
  badge?: Maybe<Scalars['JSONObject']>;
  button?: Maybe<Scalars['JSONObject']>;
  buttonText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleUpper?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<Scalars['String']>;
  upperTitle?: Maybe<Scalars['String']>;
};

export type DateFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export enum DayShortEnum {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export type DeleteDocumentationFolderInput = {
  transferDocumentationFolderId?: InputMaybe<Scalars['UUID']>;
};

export type DeleteTokenInput = {
  id: Scalars['Int'];
};

export type DeleteWizardResultInput = {
  id: Scalars['UUID'];
};

export type DeleteWorkplaceMemberInput = {
  dateOfDeath?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type Document = {
  __typename?: 'Document';
  content?: Maybe<DocumentItem>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  file?: Maybe<File>;
  id: Scalars['UUID'];
  item?: Maybe<DocumentItem>;
  items?: Maybe<Array<Maybe<DocumentItem>>>;
  previousVersionDocument?: Maybe<Document>;
  previousVersionDocumentId?: Maybe<Scalars['UUID']>;
  sync?: Maybe<SyncStatus>;
  title?: Maybe<DocumentItem>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<User>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type DocumentItemArgs = {
  type?: InputMaybe<Scalars['String']>;
};


export type DocumentItemsArgs = {
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DocumentItem = {
  __typename?: 'DocumentItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  type?: Maybe<Scalars['String']>;
};

export type DocumentTransferInput = {
  documentId: Scalars['UUID'];
  documentName?: InputMaybe<Scalars['String']>;
  targetFolder: Scalars['UUID'];
  targetUserId?: InputMaybe<Scalars['UUID']>;
};

export enum DocumentType {
  Dekurz = 'DEKURZ',
  DekurzDraft = 'DEKURZ_DRAFT',
  DekurzDraftVersion = 'DEKURZ_DRAFT_VERSION',
  MedicalHistory = 'MEDICAL_HISTORY',
  MedicalReport = 'MEDICAL_REPORT',
  MedicalRequestForm = 'MEDICAL_REQUEST_FORM'
}

export type DocumentWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<DocumentType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type DocumentationFile = {
  __typename?: 'DocumentationFile';
  avResult?: Maybe<Scalars['String']>;
  avResultExpectedTimeToComplete?: Maybe<Scalars['Int']>;
  avResultText?: Maybe<Scalars['String']>;
  canBeShared?: Maybe<Scalars['Boolean']>;
  canBeSigned?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdByName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  file?: Maybe<File>;
  fileGroupId?: Maybe<Scalars['String']>;
  fileTransfers?: Maybe<Meta>;
  fileUrl?: Maybe<Scalars['String']>;
  folder?: Maybe<DocumentationFolder>;
  folderId?: Maybe<Scalars['UUID']>;
  groupFiles?: Maybe<Array<Maybe<DocumentationFile>>>;
  hasThumb?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isEditable?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isSeen?: Maybe<Scalars['Boolean']>;
  isSeenMarkedBy?: Maybe<User>;
  isSeenMarkedById?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  virtualUser?: Maybe<User>;
  virtualUserId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type DocumentationFilesResult = {
  __typename?: 'DocumentationFilesResult';
  data?: Maybe<Array<Maybe<DocumentationFile>>>;
  meta?: Maybe<PageInfo>;
};

export type DocumentationFolder = {
  __typename?: 'DocumentationFolder';
  accessType?: Maybe<Scalars['String']>;
  canCreateFile?: Maybe<Scalars['Boolean']>;
  canSearchFile?: Maybe<Scalars['Boolean']>;
  canSwitchView?: Maybe<Scalars['Boolean']>;
  filesCount?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isEditable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parentDocumentationFolder?: Maybe<DocumentationFolder>;
  parentDocumentationFolderId?: Maybe<Scalars['UUID']>;
  permissionUsers?: Maybe<Array<Maybe<DocumentationFolderUser>>>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type DocumentationFolderUser = {
  __typename?: 'DocumentationFolderUser';
  folder?: Maybe<DocumentationFolder>;
  folderId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type DocumentationFolderWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type DocumentationFoldersResult = {
  __typename?: 'DocumentationFoldersResult';
  data?: Maybe<Array<Maybe<DocumentationFolder>>>;
  meta?: Maybe<PageInfo>;
};

export type DocumentsResult = {
  __typename?: 'DocumentsResult';
  data?: Maybe<Array<Document>>;
  meta?: Maybe<PageInfo>;
};

export type DoneEventInput = {
  eventId?: InputMaybe<Scalars['UUID']>;
};

export type DrMaxOpeningHour = {
  __typename?: 'DrMaxOpeningHour';
  from?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  open?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['DateTime']>;
};

export type DrMaxOpeningHourItem = {
  __typename?: 'DrMaxOpeningHourItem';
  date?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Array<Maybe<DrMaxOpeningHour>>>;
  nonstop?: Maybe<Scalars['Boolean']>;
  open?: Maybe<Scalars['Boolean']>;
};

export type DrMaxPickupPlace = {
  __typename?: 'DrMaxPickupPlace';
  distance?: Maybe<Scalars['Float']>;
  distanceFormatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Array<Maybe<DrMaxOpeningHourItem>>>;
  productsInStock?: Maybe<Array<Maybe<DrMaxProductsInStock>>>;
};

export type DrMaxPickupPlacesResult = {
  __typename?: 'DrMaxPickupPlacesResult';
  data?: Maybe<Array<Maybe<DrMaxPickupPlace>>>;
  meta?: Maybe<PageInfo>;
};

export type DrMaxPrescriptionMedicament = {
  __typename?: 'DrMaxPrescriptionMedicament';
  formattedApproximatePrice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  inStock?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};


export type DrMaxPrescriptionMedicamentFormattedApproximatePriceArgs = {
  drmaxPickupPlaceId?: InputMaybe<Scalars['UUID']>;
};


export type DrMaxPrescriptionMedicamentInStockArgs = {
  drmaxPickupPlaceId?: InputMaybe<Scalars['UUID']>;
};

export type DrMaxPrescriptionMedicamentsResult = {
  __typename?: 'DrMaxPrescriptionMedicamentsResult';
  data?: Maybe<Array<Maybe<DrMaxPrescriptionMedicament>>>;
  meta?: Maybe<PageInfo>;
};

export type DrMaxPrescriptionReservation = {
  __typename?: 'DrMaxPrescriptionReservation';
  incrementId?: Maybe<Scalars['String']>;
};

export type DrMaxProductsInStock = {
  __typename?: 'DrMaxProductsInStock';
  inStock?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type EducationMaterial = {
  __typename?: 'EducationMaterial';
  category?: Maybe<Scalars['String']>;
  educationMaterialFolder?: Maybe<EducationMaterialFolder>;
  educationMaterialFolderId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  module?: Maybe<EducationMaterialModule>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  seen?: Maybe<Scalars['Boolean']>;
  seenAt?: Maybe<Scalars['DateTime']>;
  send?: Maybe<Scalars['Boolean']>;
  sendAt?: Maybe<Scalars['DateTime']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};


export type EducationMaterialSeenArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSeenAtArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSendArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSendAtArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};

export type EducationMaterialFolder = {
  __typename?: 'EducationMaterialFolder';
  educationMaterials?: Maybe<Array<Maybe<EducationMaterial>>>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
};


export type EducationMaterialFolderEducationMaterialsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
};

export type EducationMaterialFoldersResult = {
  __typename?: 'EducationMaterialFoldersResult';
  data?: Maybe<Array<Maybe<EducationMaterialFolder>>>;
  meta?: Maybe<PageInfo>;
};

export enum EducationMaterialModule {
  Baby = 'BABY',
  Diabetes = 'DIABETES',
  Therapist = 'THERAPIST'
}

export type EducationMaterialsResult = {
  __typename?: 'EducationMaterialsResult';
  data?: Maybe<Array<Maybe<EducationMaterial>>>;
  meta?: Maybe<PageInfo>;
};

export type EndHealthPlanUserInput = {
  healthPlanUserId: Scalars['UUID'];
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
};

export type Event = {
  __typename?: 'Event';
  address?: Maybe<Address>;
  addressDescription?: Maybe<Scalars['String']>;
  calendar?: Maybe<Calendar>;
  calendarId?: Maybe<Scalars['ID']>;
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  createdBy?: Maybe<User>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eventMembers?: Maybe<Array<Maybe<EventMember>>>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  layout?: Maybe<Scalars['JSONObject']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  note?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tagsTermItems?: Maybe<Array<Maybe<TermItem>>>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type EventMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export type EventMember = {
  __typename?: 'EventMember';
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  role?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export enum EventType {
  Absence = 'ABSENCE',
  Block = 'BLOCK',
  Default = 'DEFAULT',
  Reservation = 'RESERVATION'
}

export type EventsResult = {
  __typename?: 'EventsResult';
  data?: Maybe<Array<Maybe<Event>>>;
  meta?: Maybe<PageInfo>;
};

export type FamilyMember = {
  __typename?: 'FamilyMember';
  canBeDeleted: Scalars['Boolean'];
  canBeShared: Scalars['Boolean'];
  id: Scalars['Int'];
  isAdmin: Scalars['Boolean'];
  role: FamilyMemberRole;
  user: User;
  userId: Scalars['UUID'];
};

export type FamilyMemberRelationInput = {
  relatedUserId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum FamilyMemberRole {
  Adult = 'ADULT',
  Child = 'CHILD',
  Invitation = 'INVITATION',
  Me = 'ME',
  Partner = 'PARTNER'
}

export type FamilyMemberWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type FamilyMembersResult = {
  __typename?: 'FamilyMembersResult';
  data?: Maybe<Array<Maybe<FamilyMember>>>;
  meta?: Maybe<PageInfo>;
};

export type File = {
  __typename?: 'File';
  avResult?: Maybe<Scalars['Int']>;
  avResultText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  extension?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['String']>;
};

export type GenerateSubscriptionRedeemCodeAlphabetInput = {
  charactersCount?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
  count: Scalars['Int'];
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['UUID'];
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type GenerateSubscriptionRedeemCodeAlphabetResult = {
  __typename?: 'GenerateSubscriptionRedeemCodeAlphabetResult';
  unsuccessfulCount?: Maybe<Scalars['Int']>;
};

export type GenerateSubscriptionRedeemCodeInput = {
  code: Scalars['String'];
  count: Scalars['Int'];
  numbersCount?: InputMaybe<Scalars['Int']>;
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['UUID']>;
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type Group = {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByLog?: Maybe<AuditLog>;
  description?: Maybe<Scalars['String']>;
  groupMembers?: Maybe<GroupMembersResult>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  totalMembers?: Maybe<Scalars['Int']>;
  updatedByLog?: Maybe<AuditLog>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type GroupGroupMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type GroupMember = {
  __typename?: 'GroupMember';
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type GroupMembersResult = {
  __typename?: 'GroupMembersResult';
  data?: Maybe<Array<Maybe<GroupMember>>>;
  meta?: Maybe<PageInfo>;
};

export type GroupsResult = {
  __typename?: 'GroupsResult';
  data?: Maybe<Array<Maybe<Group>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthCard = {
  __typename?: 'HealthCard';
  allergies?: Maybe<Scalars['String']>;
  allergiesOther?: Maybe<Scalars['String']>;
  anamnesisFamily?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  job?: Maybe<Scalars['String']>;
  operations?: Maybe<Scalars['String']>;
  sickness?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  weight?: Maybe<Scalars['Int']>;
};

export type HealthDataDashboardCategory = {
  __typename?: 'HealthDataDashboardCategory';
  extra?: Maybe<Scalars['JSONObject']>;
  iconUrl?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  title: Scalars['String'];
  trend?: Maybe<HealthDataDashboardCategoryTrend>;
  type?: Maybe<HealthDataDashboardCategoryType>;
  value: Scalars['String'];
};

export enum HealthDataDashboardCategoryTrend {
  Down = 'DOWN',
  None = 'NONE',
  Up = 'UP'
}

export enum HealthDataDashboardCategoryType {
  BioScan = 'BIO_SCAN',
  Category = 'CATEGORY'
}

export type HealthDataItem = {
  __typename?: 'HealthDataItem';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  meta?: Maybe<Array<Maybe<HealthDataItemMeta>>>;
  time?: Maybe<Scalars['DateTime']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type HealthDataItemMeta = {
  __typename?: 'HealthDataItemMeta';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type HealthDataResult = {
  __typename?: 'HealthDataResult';
  data?: Maybe<Array<Maybe<HealthDataItem>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlan = {
  __typename?: 'HealthPlan';
  active?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  doctorInitialQuestionnaireCode?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  initialQuestionnaireCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<Scalars['JSONObject']>;
  structure?: Maybe<HealthPlanStructure>;
  totalMonths?: Maybe<Scalars['Int']>;
};

export type HealthPlanBabyPregnancy = {
  __typename?: 'HealthPlanBabyPregnancy';
  dateOfDelivery?: Maybe<Scalars['Date']>;
  gestationalAgeFUM?: Maybe<Scalars['String']>;
};

export enum HealthPlanCodeEnum {
  Diabetes = 'DIABETES',
  Kdar = 'KDAR',
  Meddibaby = 'MEDDIBABY',
  Obesity = 'OBESITY',
  ObesityTherapist = 'OBESITY_THERAPIST',
  Oncology = 'ONCOLOGY',
  Palliative = 'PALLIATIVE',
  Therapist = 'THERAPIST'
}

export type HealthPlanPeriod = {
  __typename?: 'HealthPlanPeriod';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  sale?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type HealthPlanStructure = {
  __typename?: 'HealthPlanStructure';
  name: Scalars['String'];
  settings?: Maybe<Scalars['JSONObject']>;
  steps?: Maybe<Array<Maybe<HealthPlanStructureStep>>>;
};

export type HealthPlanStructureStep = {
  __typename?: 'HealthPlanStructureStep';
  key: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<HealthPlanStructureStepTypeEnum>;
};

export enum HealthPlanStructureStepTypeEnum {
  EducationMaterials = 'EDUCATION_MATERIALS',
  Form = 'FORM',
  Questionnaires = 'QUESTIONNAIRES',
  Requirements = 'REQUIREMENTS'
}

export type HealthPlanUser = {
  __typename?: 'HealthPlanUser';
  activatedAt?: Maybe<Scalars['DateTime']>;
  activeFrom?: Maybe<Scalars['DateTime']>;
  activeMonth?: Maybe<Scalars['Int']>;
  activeTo?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  endAt?: Maybe<Scalars['DateTime']>;
  hasEnded?: Maybe<Scalars['Boolean']>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanId?: Maybe<Scalars['UUID']>;
  healthPlanUserBaby?: Maybe<HealthPlanUserBaby>;
  id: Scalars['UUID'];
  initialQuestionnaireResult?: Maybe<QuestionnaireResult>;
  initialQuestionnaireResultId?: Maybe<Scalars['UUID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  offerContent?: Maybe<Scalars['String']>;
  periods?: Maybe<Array<Maybe<HealthPlanPeriod>>>;
  plannedActiveFrom?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Price>;
  priceSale?: Maybe<Price>;
  pricing?: Maybe<HealthPlanUserPricing>;
  ready?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<HealthPlanUserSettings>;
  status?: Maybe<HealthPlanUserItem>;
  statusText?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type HealthPlanUserPriceSaleArgs = {
  period: HealthPlanUserPricePeriod;
};

export type HealthPlanUserBaby = {
  __typename?: 'HealthPlanUserBaby';
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  gestionalAge?: Maybe<Scalars['String']>;
};

export type HealthPlanUserItem = {
  __typename?: 'HealthPlanUserItem';
  extra?: Maybe<Scalars['JSON']>;
  healthPlanUser?: Maybe<HealthPlanUser>;
  healthPlanUserId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type HealthPlanUserItemResult = {
  __typename?: 'HealthPlanUserItemResult';
  data?: Maybe<Array<Maybe<HealthPlanUserItem>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlanUserItemWhereInput = {
  healthPlanUserId: Scalars['UUID'];
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type HealthPlanUserPaymentInput = {
  activateHealthPlan?: InputMaybe<Scalars['Boolean']>;
  amount: Scalars['Decimal'];
  currency: Scalars['String'];
  healthPlanUserId: Scalars['UUID'];
  paymentMethod: HealthPlanUserPricingPaymentMethod;
  paymentPeriod: HealthPlanUserPricePeriod;
};

export enum HealthPlanUserPricePeriod {
  HalfYear = 'HALF_YEAR',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type HealthPlanUserPricing = {
  __typename?: 'HealthPlanUserPricing';
  creditPerDay?: Maybe<Scalars['Float']>;
  nextPayment?: Maybe<Price>;
  nextPaymentAt?: Maybe<Scalars['DateTime']>;
  payNow?: Maybe<Price>;
  paymentMethod?: Maybe<HealthPlanUserPricingPaymentMethod>;
  remainsToPay?: Maybe<Price>;
  totalPrice?: Maybe<Price>;
};

export enum HealthPlanUserPricingPaymentMethod {
  Card = 'CARD',
  Cash = 'CASH'
}

export type HealthPlanUserSettings = {
  __typename?: 'HealthPlanUserSettings';
  continueToPayment?: Maybe<Scalars['String']>;
  healthPlanContains?: Maybe<Scalars['String']>;
  healthPlanPreparedByDoctor?: Maybe<Scalars['String']>;
  hello?: Maybe<Scalars['String']>;
  howYouWannaPay?: Maybe<Scalars['String']>;
  priceContains?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topBarTitle?: Maybe<Scalars['String']>;
};

export type HealthPlanUsersResult = {
  __typename?: 'HealthPlanUsersResult';
  data?: Maybe<Array<Maybe<HealthPlanUser>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlanWorkplace = {
  __typename?: 'HealthPlanWorkplace';
  healthPlanId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type HealthPlansResult = {
  __typename?: 'HealthPlansResult';
  data?: Maybe<Array<Maybe<HealthPlan>>>;
  meta?: Maybe<PageInfo>;
};

export type HiddenWorkplaceMetaInput = {
  userId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type HideSeenQuestionnaireResult = {
  __typename?: 'HideSeenQuestionnaireResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type InsuranceOperation = {
  __typename?: 'InsuranceOperation';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  insurance?: Maybe<TermItem>;
  insuranceId?: Maybe<Scalars['UUID']>;
  ncziCode?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type InsuranceOperationResult = {
  __typename?: 'InsuranceOperationResult';
  data?: Maybe<Array<Maybe<InsuranceOperation>>>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceOperationsWhereInput = {
  insuranceId?: InputMaybe<Scalars['UUID']>;
  ncziCode?: InputMaybe<Scalars['String']>;
  workplaceId: Scalars['UUID'];
};

export type InsuranceReport = {
  __typename?: 'InsuranceReport';
  birthNumber?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['UUID']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  insurance?: Maybe<TermItem>;
  insuranceId?: Maybe<Scalars['UUID']>;
  operation?: Maybe<InsuranceOperation>;
  operationId?: Maybe<Scalars['UUID']>;
  patient?: Maybe<User>;
  patientId: Scalars['UUID'];
  points?: Maybe<Scalars['Int']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type InsuranceReportsResult = {
  __typename?: 'InsuranceReportsResult';
  data?: Maybe<Array<Maybe<InsuranceReport>>>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceReportsWhereInput = {
  doctorId?: InputMaybe<Scalars['UUID']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  patientId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  id?: Maybe<Scalars['UUID']>;
  number?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Iot = {
  __typename?: 'Iot';
  extra?: Maybe<Scalars['JSONObject']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  iotUser?: Maybe<IotUser>;
  name?: Maybe<Scalars['String']>;
  topped?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};


export type IotIotUserArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};

export type IotUser = {
  __typename?: 'IotUser';
  active?: Maybe<Scalars['Boolean']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  ingestionUrl?: Maybe<Scalars['String']>;
  iot?: Maybe<Iot>;
  iotId?: Maybe<Scalars['UUID']>;
  synchronizationNeeded?: Maybe<Scalars['Boolean']>;
  synchronizedAt?: Maybe<Scalars['DateTime']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type IotsResult = {
  __typename?: 'IotsResult';
  data?: Maybe<Array<Maybe<Iot>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoriesWhereInput = {
  fulltext?: InputMaybe<Scalars['String']>;
};

export type Laboratory = {
  __typename?: 'Laboratory';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  icl?: Maybe<Scalars['String']>;
  ico?: Maybe<Scalars['String']>;
  icp?: Maybe<Scalars['String']>;
  icz?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type LaboratoryDataInput = {
  key: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  type: LaboratoryDataType;
  value: Scalars['String'];
};

export enum LaboratoryDataType {
  Note = 'NOTE',
  RequestItem = 'REQUEST_ITEM'
}

export type LaboratoryDocumentInput = {
  primarySampleType: Scalars['String'];
  selfPaid: Scalars['Boolean'];
  statim: Scalars['Boolean'];
};

export type LaboratoryDocumentType = {
  __typename?: 'LaboratoryDocumentType';
  primarySampleType?: Maybe<Scalars['String']>;
  selfPaid?: Maybe<Scalars['Boolean']>;
  statim?: Maybe<Scalars['Boolean']>;
};

export type LaboratoryPatientInput = {
  address?: InputMaybe<AddressInput>;
  birthDate: Scalars['Date'];
  diagnosisTermItemId: Scalars['String'];
  firstName: Scalars['String'];
  genderTermItemId: Scalars['UUID'];
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  insuranceNumber: Scalars['String'];
  lastName: Scalars['String'];
};

export type LaboratoryRequisition = {
  __typename?: 'LaboratoryRequisition';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  laboratory: Laboratory;
  laboratoryId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionForm = {
  __typename?: 'LaboratoryRequisitionForm';
  items?: Maybe<Scalars['JSON']>;
  samples?: Maybe<Array<Maybe<LaboratoryRequisitionSample>>>;
  settings?: Maybe<Scalars['JSON']>;
};

export type LaboratoryRequisitionFormResult = {
  __typename?: 'LaboratoryRequisitionFormResult';
  form?: Maybe<LaboratoryRequisitionForm>;
  requisition?: Maybe<LaboratoryRequisition>;
};

export type LaboratoryRequisitionFormWhereInput = {
  id: Scalars['UUID'];
};

export type LaboratoryRequisitionPatient = {
  __typename?: 'LaboratoryRequisitionPatient';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  age?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthNumber?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<TermItem>;
  diagnosisTermItemId?: Maybe<Scalars['UUID']>;
  fatherLastName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedBirthNumber?: Maybe<Scalars['String']>;
  formattedGender?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderTermItem?: Maybe<TermItem>;
  genderTermItemId?: Maybe<Scalars['UUID']>;
  hasInsurance?: Maybe<Scalars['Boolean']>;
  insuranceCompanyTermItem?: Maybe<TermItem>;
  insuranceCompanyTermItemId?: Maybe<Scalars['UUID']>;
  insuranceNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  motherLastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationalityOther?: Maybe<Scalars['String']>;
  nationalityTermItem?: Maybe<TermItem>;
  nationalityTermItemId?: Maybe<Scalars['UUID']>;
  salutation?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionResult = {
  __typename?: 'LaboratoryRequisitionResult';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  document?: Maybe<LaboratoryDocumentType>;
  id: Scalars['UUID'];
  patient: LaboratoryRequisitionPatient;
  requisition?: Maybe<LaboratoryRequisition>;
  result?: Maybe<Array<Maybe<LaboratoryResultType>>>;
  user: User;
  workplace: Workplace;
};

export type LaboratoryRequisitionResultWhereInput = {
  id: Scalars['UUID'];
};

export type LaboratoryRequisitionResultsResult = {
  __typename?: 'LaboratoryRequisitionResultsResult';
  data?: Maybe<Array<Maybe<LaboratoryRequisitionResult>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryRequisitionResultsWhereInput = {
  requisitionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type LaboratoryRequisitionSample = {
  __typename?: 'LaboratoryRequisitionSample';
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionsResult = {
  __typename?: 'LaboratoryRequisitionsResult';
  data?: Maybe<Array<Maybe<LaboratoryRequisition>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryRequisitionsWhereInput = {
  laboratoryId: Scalars['UUID'];
};

export type LaboratoryResult = {
  __typename?: 'LaboratoryResult';
  data?: Maybe<Array<Maybe<Laboratory>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryResultType = {
  __typename?: 'LaboratoryResultType';
  key: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  type: LaboratoryDataType;
  value: Scalars['String'];
};

export type LaboratoryWizard = {
  __typename?: 'LaboratoryWizard';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  laboratory?: Maybe<Laboratory>;
  laboratoryId?: Maybe<Scalars['UUID']>;
  type?: Maybe<LaboratoryWizardType>;
  wizard?: Maybe<Wizard>;
  wizardId?: Maybe<Scalars['UUID']>;
};

export enum LaboratoryWizardType {
  Document = 'DOCUMENT',
  MedicalRequest = 'MEDICAL_REQUEST'
}

export type LaboratoryWizardsResult = {
  __typename?: 'LaboratoryWizardsResult';
  data?: Maybe<Array<Maybe<LaboratoryWizard>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryWizardsWhereInput = {
  laboratoryId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<LaboratoryWizardType>;
};

export type MarkAsSeenUserNotificationsResult = {
  __typename?: 'MarkAsSeenUserNotificationsResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type MeddiAccount = {
  __typename?: 'MeddiAccount';
  balance?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  members?: Maybe<Array<Maybe<MeddiAccountMember>>>;
  type?: Maybe<MeddiAccountType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MeddiAccountMember = {
  __typename?: 'MeddiAccountMember';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  role?: Maybe<MeddiAccountMemberRole>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum MeddiAccountMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type MeddiAccountResult = {
  __typename?: 'MeddiAccountResult';
  data?: Maybe<Array<Maybe<MeddiAccount>>>;
  meta?: Maybe<PageInfo>;
};

export type MeddiAccountTransactionResult = {
  __typename?: 'MeddiAccountTransactionResult';
  data?: Maybe<Array<Maybe<MeddiTransaction>>>;
  meta?: Maybe<PageInfo>;
};

export type MeddiAccountTransactionsWhereInput = {
  meddiAccountId?: InputMaybe<Scalars['UUID']>;
  meddiAccountType?: InputMaybe<MeddiAccountType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum MeddiAccountType {
  Company = 'COMPANY',
  Default = 'DEFAULT'
}

export type MeddiAccountsWhereInput = {
  type?: InputMaybe<MeddiAccountType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type MeddiSettings = {
  __typename?: 'MeddiSettings';
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type MeddiTransaction = {
  __typename?: 'MeddiTransaction';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['UUID']>;
  meddiAccount?: Maybe<MeddiAccount>;
  meddiAccountId?: Maybe<Scalars['UUID']>;
  order?: Maybe<TransactionOrder>;
  orderId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
};

export type MedicalReport = {
  __typename?: 'MedicalReport';
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['UUID']>;
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  printed?: Maybe<Scalars['Boolean']>;
  treatment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['String']>;
};

export type MedicalRequestForm = {
  __typename?: 'MedicalRequestForm';
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  wizardKey?: Maybe<Scalars['String']>;
};

export type MedicalRequestFormsResult = {
  __typename?: 'MedicalRequestFormsResult';
  data?: Maybe<Array<Maybe<MedicalRequestForm>>>;
  meta?: Maybe<PageInfo>;
};

export type Medium = {
  __typename?: 'Medium';
  artwork?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  metadata?: Maybe<MetadataType>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSONObject']>;
  url?: Maybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['JSONObject']>;
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  messageAttachments?: Maybe<Array<Maybe<MessageAttachment>>>;
  messageMembers?: Maybe<Array<Maybe<MessageMember>>>;
  myMessageMember?: Maybe<MessageMember>;
  sender?: Maybe<MessageMember>;
  singleRecipient?: Maybe<MessageMember>;
  totalRecipients?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};


export type MessageMessageAttachmentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type MessageMessageMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  documentationFile?: Maybe<DocumentationFile>;
  documentationFileId?: Maybe<Scalars['UUID']>;
  educationMaterial?: Maybe<EducationMaterial>;
  educationMaterialId?: Maybe<Scalars['UUID']>;
  extra?: Maybe<Scalars['JSON']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['UUID']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  type?: Maybe<MessageAttachmentType>;
};

export enum MessageAttachmentType {
  DocumentationFile = 'DOCUMENTATION_FILE',
  EducationMaterial = 'EDUCATION_MATERIAL',
  File = 'FILE',
  Form = 'FORM',
  Questionnaire = 'QUESTIONNAIRE'
}

export type MessageAttachmentsResult = {
  __typename?: 'MessageAttachmentsResult';
  data?: Maybe<Array<Maybe<MessageAttachment>>>;
  meta?: Maybe<PageInfo>;
};

export type MessageMember = {
  __typename?: 'MessageMember';
  id: Scalars['UUID'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['UUID']>;
  seen?: Maybe<Scalars['Boolean']>;
  sender?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MessageMembersResult = {
  __typename?: 'MessageMembersResult';
  data?: Maybe<Array<Maybe<MessageMember>>>;
  meta?: Maybe<PageInfo>;
};

export type MessagesResult = {
  __typename?: 'MessagesResult';
  data?: Maybe<Array<Maybe<Message>>>;
  meta?: Maybe<PageInfo>;
};

export type Meta = {
  __typename?: 'Meta';
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type MetaTranslation = {
  __typename?: 'MetaTranslation';
  id?: Maybe<Scalars['UUID']>;
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type MetadataType = {
  __typename?: 'MetadataType';
  album?: Maybe<Scalars['String']>;
  artist?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  genre?: Maybe<Scalars['String']>;
};

export type MetasResult = {
  __typename?: 'MetasResult';
  data?: Maybe<Array<Maybe<WorkplaceCaseType>>>;
  meta?: Maybe<PageInfo>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateUserSubscriptionByRedeemCode?: Maybe<UserSubscription>;
  assignCase?: Maybe<Case>;
  bulkUserHealthCategoryPermission?: Maybe<Array<Maybe<UserHealthCategoryPermission>>>;
  cancelDrMaxReservation?: Maybe<CancelDrMaxReservationResult>;
  createDrMaxPrescriptionReservation?: Maybe<DrMaxPrescriptionReservation>;
  createEvent?: Maybe<Event>;
  createGroup?: Maybe<Group>;
  createHealthPlan?: Maybe<HealthPlan>;
  createHealthPlanUser?: Maybe<HealthPlanUser>;
  createHealthPlanUserFromData?: Maybe<HealthPlanUser>;
  createHealthPlanUserPayment?: Maybe<HealthPlanUser>;
  createHealthPlanWorkplace?: Maybe<HealthPlanWorkplace>;
  createInsuranceOperation?: Maybe<InsuranceOperation>;
  createInsuranceReport?: Maybe<InsuranceReport>;
  createLaboratory?: Maybe<Laboratory>;
  createLaboratoryWizard?: Maybe<LaboratoryWizard>;
  createNote?: Maybe<Note>;
  createOrUpdateQuestionnaireResultMember?: Maybe<QuestionnaireResultMember>;
  createPlaylist?: Maybe<Playlist>;
  createPlaylistMedium?: Maybe<PlaylistMedium>;
  createRating?: Maybe<Rating>;
  createSubscription?: Maybe<Subscription>;
  createSubscriptionGroup?: Maybe<SubscriptionGroup>;
  createSubscriptionRedeemCode?: Maybe<SubscriptionRedeemCode>;
  createToken?: Maybe<Token>;
  createUserMetaTranslation?: Maybe<User>;
  createUserSubscriptionMember?: Maybe<UserSubscriptionMember>;
  createWizardResult?: Maybe<WizardResult>;
  createWorkplaceMemberAbsence?: Maybe<EventsResult>;
  createWorkplacePreset?: Maybe<WorkplacePreset>;
  deleteDocumentationFolder?: Maybe<MutationResult>;
  deleteHealthPlanWorkplace?: Maybe<HealthPlanWorkplace>;
  deleteHiddenWorkplace?: Maybe<Meta>;
  deleteInsuranceOperation?: Maybe<MutationResult>;
  deleteInsuranceReport?: Maybe<MutationResult>;
  deleteToken?: Maybe<Token>;
  deleteWizardResult?: Maybe<MutationResult>;
  deleteWorkplaceMember?: Maybe<MutationResult>;
  doneEvent?: Maybe<Event>;
  endHealthPlanUser?: Maybe<HealthPlanUser>;
  familyMemberRelation?: Maybe<FamilyMember>;
  generateSubscriptionRedeemCodes?: Maybe<Array<Maybe<SubscriptionRedeemCode>>>;
  generateSubscriptionRedeemCodesAlphabet?: Maybe<GenerateSubscriptionRedeemCodeAlphabetResult>;
  hideMembersWorkplace?: Maybe<Meta>;
  hideSeenQuestionnaireResults?: Maybe<HideSeenQuestionnaireResult>;
  markAsSeenUserNotifications?: Maybe<MarkAsSeenUserNotificationsResult>;
  orderSubscription?: Maybe<SubscriptionOrder>;
  priorityCase?: Maybe<Case>;
  purchaseProduct?: Maybe<ProductOrder>;
  reAssignCase?: Maybe<Case>;
  reactivateExpiredSubscription?: Maybe<SubscriptionOrder>;
  readDashboardMessage?: Maybe<Message>;
  refreshSettings?: Maybe<MutationResult>;
  removeUserSubscriptionMember?: Maybe<UserSubscriptionMember>;
  requestPaymentHealthPlanUser?: Maybe<HealthPlanUser>;
  saveLaboratoryRequisitionResult?: Maybe<LaboratoryRequisitionResult>;
  saveUserFilter?: Maybe<Meta>;
  submitQuestionnaireResult?: Maybe<QuestionnaireResult>;
  submitWizard?: Maybe<SubmitWizardResult>;
  transferDocument?: Maybe<DocumentationFile>;
  tryChargeExpiredSubscription?: Maybe<ChargeStatus>;
  updateDocumentationFolder?: Maybe<DocumentationFolder>;
  updateNote?: Maybe<Note>;
  updateUserConsent?: Maybe<UserConsent>;
  updateWorkplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
  userSubscriptionCancel?: Maybe<MutationResult>;
  workplacePatientDocumentationFilesMarkAsSeen?: Maybe<MutationResult>;
};


export type MutationActivateUserSubscriptionByRedeemCodeArgs = {
  input?: InputMaybe<ActivateUserSubscriptionByRedeemCode>;
};


export type MutationAssignCaseArgs = {
  input?: InputMaybe<ReAssignCaseInput>;
};


export type MutationBulkUserHealthCategoryPermissionArgs = {
  input?: InputMaybe<BulkUserHealthCategoryPermissionInput>;
};


export type MutationCancelDrMaxReservationArgs = {
  input?: InputMaybe<CancelDrMaxReservationInput>;
};


export type MutationCreateDrMaxPrescriptionReservationArgs = {
  input?: InputMaybe<CreateDrMaxPrescriptionReservationInput>;
};


export type MutationCreateEventArgs = {
  input?: InputMaybe<CreateEventInput>;
};


export type MutationCreateGroupArgs = {
  input?: InputMaybe<CreateGroupInput>;
};


export type MutationCreateHealthPlanArgs = {
  input?: InputMaybe<CreateHealthPlanInput>;
};


export type MutationCreateHealthPlanUserArgs = {
  input?: InputMaybe<CreateHealthPlanUserInput>;
};


export type MutationCreateHealthPlanUserFromDataArgs = {
  input?: InputMaybe<CreateHealthPlanUserFromDataInput>;
};


export type MutationCreateHealthPlanUserPaymentArgs = {
  input?: InputMaybe<HealthPlanUserPaymentInput>;
};


export type MutationCreateHealthPlanWorkplaceArgs = {
  input?: InputMaybe<CreateHealthPlanWorkplaceInput>;
};


export type MutationCreateInsuranceOperationArgs = {
  input?: InputMaybe<CreateOperationReportInput>;
};


export type MutationCreateInsuranceReportArgs = {
  input?: InputMaybe<CreateInsuranceReportInput>;
};


export type MutationCreateLaboratoryArgs = {
  input?: InputMaybe<CreateLaboratoryInput>;
};


export type MutationCreateLaboratoryWizardArgs = {
  input?: InputMaybe<CreateLaboratoryWizardInput>;
};


export type MutationCreateNoteArgs = {
  input?: InputMaybe<CreateNoteInput>;
};


export type MutationCreateOrUpdateQuestionnaireResultMemberArgs = {
  input?: InputMaybe<CreateOrUpdateQuestionnaireResultMemberInput>;
};


export type MutationCreatePlaylistArgs = {
  input?: InputMaybe<PlaylistInput>;
};


export type MutationCreatePlaylistMediumArgs = {
  input?: InputMaybe<PlaylistMediumInput>;
};


export type MutationCreateRatingArgs = {
  input?: InputMaybe<CreateRatingInput>;
};


export type MutationCreateSubscriptionArgs = {
  input?: InputMaybe<CreateSubscriptionInput>;
};


export type MutationCreateSubscriptionGroupArgs = {
  input?: InputMaybe<CreateSubscriptionGroup>;
};


export type MutationCreateSubscriptionRedeemCodeArgs = {
  input?: InputMaybe<CreateSubscriptionRedeemCodeInput>;
};


export type MutationCreateTokenArgs = {
  input?: InputMaybe<CreateTokenInput>;
};


export type MutationCreateUserMetaTranslationArgs = {
  input?: InputMaybe<Array<InputMaybe<UserMetaTranslationInput>>>;
};


export type MutationCreateUserSubscriptionMemberArgs = {
  input?: InputMaybe<CreateUserSubscriptionMemberInput>;
};


export type MutationCreateWizardResultArgs = {
  input: CreateWizardResultInput;
};


export type MutationCreateWorkplaceMemberAbsenceArgs = {
  input?: InputMaybe<CreateWorkplaceMemberAbsenceInput>;
};


export type MutationCreateWorkplacePresetArgs = {
  input?: InputMaybe<CreateWorkplacePresetInput>;
};


export type MutationDeleteDocumentationFolderArgs = {
  data?: InputMaybe<DeleteDocumentationFolderInput>;
  where?: InputMaybe<DocumentationFolderWhereInput>;
};


export type MutationDeleteHealthPlanWorkplaceArgs = {
  input?: InputMaybe<RemoveHealthPlanWorkplaceInput>;
};


export type MutationDeleteHiddenWorkplaceArgs = {
  input?: InputMaybe<HiddenWorkplaceMetaInput>;
};


export type MutationDeleteInsuranceOperationArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteInsuranceReportArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteTokenArgs = {
  input?: InputMaybe<DeleteTokenInput>;
};


export type MutationDeleteWizardResultArgs = {
  input: DeleteWizardResultInput;
};


export type MutationDeleteWorkplaceMemberArgs = {
  input?: InputMaybe<DeleteWorkplaceMemberInput>;
};


export type MutationDoneEventArgs = {
  input?: InputMaybe<DoneEventInput>;
};


export type MutationEndHealthPlanUserArgs = {
  input?: InputMaybe<EndHealthPlanUserInput>;
};


export type MutationFamilyMemberRelationArgs = {
  input?: InputMaybe<FamilyMemberRelationInput>;
};


export type MutationGenerateSubscriptionRedeemCodesArgs = {
  input?: InputMaybe<GenerateSubscriptionRedeemCodeInput>;
};


export type MutationGenerateSubscriptionRedeemCodesAlphabetArgs = {
  input?: InputMaybe<GenerateSubscriptionRedeemCodeAlphabetInput>;
};


export type MutationHideMembersWorkplaceArgs = {
  input?: InputMaybe<HiddenWorkplaceMetaInput>;
};


export type MutationOrderSubscriptionArgs = {
  input?: InputMaybe<OrderSubscriptionInput>;
};


export type MutationPriorityCaseArgs = {
  input?: InputMaybe<PriorityCaseInput>;
};


export type MutationPurchaseProductArgs = {
  input?: InputMaybe<PurchaseProductInput>;
};


export type MutationReAssignCaseArgs = {
  input?: InputMaybe<ReAssignCaseInput>;
};


export type MutationReactivateExpiredSubscriptionArgs = {
  input?: InputMaybe<ReactivateSubscriptionInput>;
};


export type MutationReadDashboardMessageArgs = {
  input?: InputMaybe<ReadDashboardMessageInput>;
};


export type MutationRemoveUserSubscriptionMemberArgs = {
  input?: InputMaybe<RemoveUserSubscriptionMemberInput>;
};


export type MutationRequestPaymentHealthPlanUserArgs = {
  input?: InputMaybe<RequestPaymentHealthPlanUserInput>;
};


export type MutationSaveLaboratoryRequisitionResultArgs = {
  input: SaveLaboratoryRequisitionResultInput;
};


export type MutationSaveUserFilterArgs = {
  input?: InputMaybe<UserFilterInput>;
};


export type MutationSubmitQuestionnaireResultArgs = {
  input?: InputMaybe<SubmitQuestionnaireResultInput>;
};


export type MutationSubmitWizardArgs = {
  input?: InputMaybe<WizardResultInput>;
};


export type MutationTransferDocumentArgs = {
  input?: InputMaybe<DocumentTransferInput>;
};


export type MutationTryChargeExpiredSubscriptionArgs = {
  input?: InputMaybe<ChargeSubscriptionInput>;
};


export type MutationUpdateDocumentationFolderArgs = {
  data?: InputMaybe<UpdateDocumentationFolderInput>;
  where?: InputMaybe<DocumentationFolderWhereInput>;
};


export type MutationUpdateNoteArgs = {
  input?: InputMaybe<UpdateNoteInput>;
};


export type MutationUpdateUserConsentArgs = {
  data?: InputMaybe<UpdateUserConsentInput>;
  where?: InputMaybe<UserConsentsWhereInput>;
};


export type MutationUpdateWorkplaceMembersArgs = {
  input?: InputMaybe<UpdateWorkplaceMembersInput>;
};


export type MutationUserSubscriptionCancelArgs = {
  input?: InputMaybe<UserSubscriptionCancelInput>;
};

export type MutationResult = {
  __typename?: 'MutationResult';
  status?: Maybe<Scalars['Boolean']>;
};

export type MyFamily = {
  __typename?: 'MyFamily';
  familyMembers?: Maybe<Array<Maybe<MyFamilyMember>>>;
  id: Scalars['UUID'];
};

export type MyFamilyMember = {
  __typename?: 'MyFamilyMember';
  familyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MyFamilyMembersResult = {
  __typename?: 'MyFamilyMembersResult';
  data?: Maybe<Array<Maybe<MyFamilyMember>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziCodingScheme = {
  __typename?: 'NcziCodingScheme';
  oid: Scalars['String'];
};

export type NcziCodingSchemeVersioned = {
  __typename?: 'NcziCodingSchemeVersioned';
  oid: Scalars['String'];
  version: Scalars['String'];
};

export type NcziDiagnosisItem = {
  __typename?: 'NcziDiagnosisItem';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enum: NcziEnum;
  name: Scalars['String'];
  ncziCode: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziDiagnosisItemsResult = {
  __typename?: 'NcziDiagnosisItemsResult';
  data?: Maybe<Array<Maybe<NcziDiagnosisItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziEnum = {
  __typename?: 'NcziEnum';
  extraAttr?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oid: Scalars['String'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type NcziEnumItem = {
  __typename?: 'NcziEnumItem';
  abbreviation?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enum: NcziEnum;
  name: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziEnumItemsByCodeResult = {
  __typename?: 'NcziEnumItemsByCodeResult';
  enum?: Maybe<NcziEnum>;
  enumItems?: Maybe<Array<Maybe<NcziEnumItem>>>;
};

export type NcziEnumItemsResult = {
  __typename?: 'NcziEnumItemsResult';
  data?: Maybe<Array<Maybe<NcziEnumItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziEnumsResult = {
  __typename?: 'NcziEnumsResult';
  data?: Maybe<Array<Maybe<NcziEnum>>>;
};

export type NcziExtension = {
  __typename?: 'NcziExtension';
  name: Scalars['String'];
  oid: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NcziExtensionItem = {
  __typename?: 'NcziExtensionItem';
  abbreviation?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  extension: NcziExtension;
  name: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziExtensionItemsResult = {
  __typename?: 'NcziExtensionItemsResult';
  data?: Maybe<Array<Maybe<NcziExtensionItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziMedicamentItem = {
  __typename?: 'NcziMedicamentItem';
  additionalName: Scalars['String'];
  antibioticsChemotherapy: Scalars['Boolean'];
  atc?: Maybe<NcziReference>;
  code: Scalars['String'];
  form?: Maybe<NcziReference>;
  genericPrescription: Scalars['Boolean'];
  indicationGroup?: Maybe<NcziReference>;
  multiplePrescription: Scalars['Boolean'];
  name: Scalars['String'];
  ncziCode: Scalars['String'];
  opl: Scalars['Boolean'];
  packageSize?: Maybe<NcziQuantity>;
  prescriptionValidity?: Maybe<NcziQuantity>;
  submissionPath?: Maybe<NcziReference>;
  vaccination: Scalars['Boolean'];
};

export type NcziMedicamentItemsResult = {
  __typename?: 'NcziMedicamentItemsResult';
  data?: Maybe<Array<Maybe<NcziMedicamentItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziMessage = {
  __typename?: 'NcziMessage';
  createdAt?: Maybe<Scalars['String']>;
  extraParams?: Maybe<Scalars['JSON']>;
  finished?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  lastState?: Maybe<Scalars['String']>;
  resultCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

export type NcziNExtension = {
  __typename?: 'NcziNExtension';
  code: Scalars['String'];
  scheme: NcziCodingScheme;
  valid?: Maybe<NcziValidity>;
};

export type NcziOupZsItem = {
  __typename?: 'NcziOUPZsItem';
  code: Scalars['String'];
  extension?: Maybe<NcziNExtension>;
  name: Scalars['String'];
  provider?: Maybe<NcziPzsProvider>;
  specialization?: Maybe<Array<Maybe<NcziZPrSpecialization>>>;
};

export type NcziPzsProvider = {
  __typename?: 'NcziPZSProvider';
  code: Scalars['String'];
  extension?: Maybe<NcziNExtension>;
  name: Scalars['String'];
};

export type NcziProductItem = {
  __typename?: 'NcziProductItem';
  additionalName?: Maybe<Scalars['String']>;
  antibioticsChemotherapy?: Maybe<Scalars['Boolean']>;
  atc?: Maybe<NcziReference>;
  atcAddon?: Maybe<Scalars['String']>;
  atcCode?: Maybe<Scalars['String']>;
  atcName?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  ioNeeded?: Maybe<Scalars['Boolean']>;
  ioOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  opl?: Maybe<Scalars['Boolean']>;
  quantityLimit?: Maybe<Array<Maybe<Scalars['String']>>>;
  tailored?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  ventilator?: Maybe<Scalars['Boolean']>;
};

export type NcziProductItemsResult = {
  __typename?: 'NcziProductItemsResult';
  data?: Maybe<Array<Maybe<NcziProductItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziQuantity = {
  __typename?: 'NcziQuantity';
  amount?: Maybe<Scalars['String']>;
  unit?: Maybe<NcziReference>;
};

export type NcziQueueResult = {
  __typename?: 'NcziQueueResult';
  data?: Maybe<Array<Maybe<NcziMessage>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziReference = {
  __typename?: 'NcziReference';
  code: Scalars['String'];
  displayName: Scalars['String'];
  scheme: NcziCodingSchemeVersioned;
};

export type NcziValidity = {
  __typename?: 'NcziValidity';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type NcziZPrSpecialization = {
  __typename?: 'NcziZPrSpecialization';
  ZPrCode: Scalars['String'];
  specialization: NcziReference;
};

export type Note = {
  __typename?: 'Note';
  id?: Maybe<Scalars['UUID']>;
  text?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  commission?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  issueDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  orderLog?: Maybe<OrderLog>;
  orderLogs?: Maybe<Array<Maybe<OrderLog>>>;
  orderMembers?: Maybe<Array<Maybe<OrderMember>>>;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  price?: Maybe<TransactionPrice>;
  priceInvoicing?: Maybe<Scalars['String']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
};

export type OrderLog = {
  __typename?: 'OrderLog';
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OrderMember = {
  __typename?: 'OrderMember';
  type?: Maybe<OrderMemberType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum OrderMemberType {
  Issuer = 'Issuer',
  Payer = 'Payer'
}

export enum OrderPaymentMethod {
  Apay = 'APAY',
  Crd = 'CRD',
  Edenred = 'EDENRED',
  Gpay = 'GPAY',
  MeddiCredit = 'MEDDI_CREDIT',
  Paypal = 'PAYPAL',
  Sodexo = 'SODEXO'
}

export type OrderStatistics = {
  __typename?: 'OrderStatistics';
  currency?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  totalCommission?: Maybe<Scalars['Float']>;
  totalInvoiced?: Maybe<Scalars['Float']>;
};

export type OrderStatisticsResult = {
  __typename?: 'OrderStatisticsResult';
  data?: Maybe<Array<Maybe<OrderStatistics>>>;
};

export type OrderStatisticsWhereInput = {
  from: Scalars['DateTime'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orderMembers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sendEmpty?: InputMaybe<Scalars['Boolean']>;
  to: Scalars['DateTime'];
  workplaceId?: InputMaybe<Scalars['String']>;
};

export type OrderStats = {
  __typename?: 'OrderStats';
  commissionTotal?: Maybe<Scalars['Decimal']>;
  commissionTotalFormatted?: Maybe<Scalars['String']>;
  invoicedTotal?: Maybe<Scalars['Decimal']>;
  invoicedTotalFormatted?: Maybe<Scalars['String']>;
};

export enum OrderStatus {
  Created = 'CREATED',
  Paid = 'PAID'
}

export type OrderSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  subscriptionPeriodId?: InputMaybe<Scalars['String']>;
};

export type OrdersFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orderMembers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<OrderStatus>;
  to?: InputMaybe<Scalars['DateTime']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type OrdersResult = {
  __typename?: 'OrdersResult';
  data?: Maybe<Array<Maybe<Order>>>;
  meta?: Maybe<PageInfo>;
  stats?: Maybe<OrderStats>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  next?: Maybe<Scalars['JSONObject']>;
  page?: Maybe<Scalars['Int']>;
  params?: Maybe<Scalars['JSONObject']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PaginationInput = {
  order?: InputMaybe<PaginationInputOrder>;
  page?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginationInputOrder = {
  how?: InputMaybe<PaginationOrderHow>;
  key?: InputMaybe<Scalars['String']>;
};

export enum PaginationOrderHow {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PatientCalculator = {
  __typename?: 'PatientCalculator';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  wizardKey: Scalars['String'];
};

export type PatientCalculatorsResult = {
  __typename?: 'PatientCalculatorsResult';
  data?: Maybe<Array<Maybe<PatientCalculator>>>;
  meta?: Maybe<PageInfo>;
};

export type PaySubscriptionInput = {
  subscriptionId?: InputMaybe<Scalars['String']>;
  subscriptionPeriodId?: InputMaybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  icon?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Playlist = {
  __typename?: 'Playlist';
  code?: Maybe<PlaylistCode>;
  id: Scalars['UUID'];
  mediums?: Maybe<Array<Maybe<Medium>>>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PlaylistType>;
};

export enum PlaylistCode {
  Medditation = 'MEDDITATION'
}

export type PlaylistInput = {
  code: PlaylistCode;
  name: Scalars['String'];
  type: PlaylistType;
};

export type PlaylistMedium = {
  __typename?: 'PlaylistMedium';
  id: Scalars['UUID'];
  mediumId?: Maybe<Scalars['UUID']>;
  playlistId?: Maybe<Scalars['UUID']>;
};

export type PlaylistMediumInput = {
  mediumId: Scalars['UUID'];
  playlistId: Scalars['UUID'];
};

export enum PlaylistType {
  Default = 'DEFAULT'
}

export type PlaylistsResult = {
  __typename?: 'PlaylistsResult';
  data?: Maybe<Array<Maybe<Playlist>>>;
  meta?: Maybe<PageInfo>;
};

export type Post = {
  __typename?: 'Post';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PostsResult = {
  __typename?: 'PostsResult';
  data?: Maybe<Array<Maybe<Post>>>;
  meta?: Maybe<PageInfo>;
};

export type Prescription = {
  __typename?: 'Prescription';
  canBeReserved?: Maybe<Scalars['Boolean']>;
  canDrmax?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  createdByName?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSONObject']>;
  drMaxPickupPlace?: Maybe<DrMaxPickupPlace>;
  id: Scalars['UUID'];
  items?: Maybe<Array<Maybe<PrescriptionItem>>>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type PrescriptionItem = {
  __typename?: 'PrescriptionItem';
  childPrescriptionItems?: Maybe<Array<Maybe<PrescriptionItem>>>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  parentPrescriptionItem?: Maybe<PrescriptionItem>;
  parentPrescriptionItemId?: Maybe<Scalars['UUID']>;
  prescription?: Maybe<Prescription>;
  prescriptionId?: Maybe<Scalars['UUID']>;
  prescriptionMedicament?: Maybe<PrescriptionMedicament>;
  prescriptionMedicamentId?: Maybe<Scalars['UUID']>;
  quantity?: Maybe<Scalars['Decimal']>;
};

export type PrescriptionItemsResult = {
  __typename?: 'PrescriptionItemsResult';
  data?: Maybe<Array<Maybe<PrescriptionItem>>>;
  meta?: Maybe<PageInfo>;
};

export type PrescriptionMedicament = {
  __typename?: 'PrescriptionMedicament';
  addition?: Maybe<Scalars['String']>;
  atc?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  dispensing?: Maybe<Scalars['String']>;
  dispensingTermItem?: Maybe<TermItem>;
  doping?: Maybe<Scalars['String']>;
  dopingTermItem?: Maybe<TermItem>;
  form?: Maybe<Scalars['String']>;
  hasIndicationLimitations?: Maybe<Scalars['Boolean']>;
  hasLimitations?: Maybe<Scalars['Boolean']>;
  hasSpecialityLimitations?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  indicationLimitations?: Maybe<Scalars['String']>;
  lim?: Maybe<Scalars['String']>;
  limTermItem?: Maybe<TermItem>;
  name?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  priceExtraFormatted?: Maybe<Scalars['String']>;
  priceInsuranceCompanyRawFormatted?: Maybe<Scalars['String']>;
  priceRawFormatted?: Maybe<Scalars['String']>;
  rationalPrescription?: Maybe<Scalars['String']>;
  routeOfAdministration?: Maybe<Scalars['String']>;
  specialityLimitationTermItems?: Maybe<Array<Maybe<TermItem>>>;
  specialityLimitations?: Maybe<Scalars['String']>;
  strength?: Maybe<Scalars['String']>;
};

export type PrescriptionMedicamentsResult = {
  __typename?: 'PrescriptionMedicamentsResult';
  data?: Maybe<Array<Maybe<PrescriptionMedicament>>>;
  meta?: Maybe<PageInfo>;
};

export enum PrescriptionType {
  Default = 'DEFAULT',
  Sukl = 'SUKL'
}

export type PrescriptionsResult = {
  __typename?: 'PrescriptionsResult';
  data?: Maybe<Array<Maybe<Prescription>>>;
  meta?: Maybe<PageInfo>;
};

export type Price = {
  __typename?: 'Price';
  currency: Scalars['String'];
  formattedPrice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Decimal']>;
  priceWithVat?: Maybe<Scalars['Decimal']>;
  priceWithVatRaw?: Maybe<Scalars['String']>;
  vatRate: Scalars['Int'];
};

export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  absoluteDiscountFormatted?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  relativeDiscount?: Maybe<Scalars['Decimal']>;
};

export type PriorityCaseInput = {
  caseId: Scalars['UUID'];
  priorityId?: InputMaybe<Scalars['UUID']>;
};

export type Product = {
  __typename?: 'Product';
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formattedPrice?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  productGroup?: Maybe<Scalars['String']>;
  purchaseButton?: Maybe<ProductPurchaseButton>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductItem = {
  __typename?: 'ProductItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  productId: Scalars['UUID'];
  quantity?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductOrder = {
  __typename?: 'ProductOrder';
  id: Scalars['UUID'];
  number?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['UUID']>;
  orderItems?: Maybe<Array<Maybe<ProductOrderItem>>>;
  price?: Maybe<ProductOrderPrice>;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type ProductOrderItem = {
  __typename?: 'ProductOrderItem';
  code?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
};

export type ProductOrderPrice = {
  __typename?: 'ProductOrderPrice';
  currency?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  price?: Maybe<Scalars['Float']>;
  pricePiece?: Maybe<Scalars['Int']>;
  priceWithVat?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  vatRate?: Maybe<Scalars['Int']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  pricePieceWithVat?: Maybe<Scalars['Float']>;
  productId: Scalars['UUID'];
  vatRate?: Maybe<Scalars['Int']>;
};

export type ProductPurchaseButton = {
  __typename?: 'ProductPurchaseButton';
  description?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  age?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthNumber?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  fatherLastName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedBirthNumber?: Maybe<Scalars['String']>;
  formattedGender?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderTermItem?: Maybe<TermItem>;
  genderTermItemId?: Maybe<Scalars['UUID']>;
  hasInsurance?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  insuranceCompanyTermItem?: Maybe<TermItem>;
  insuranceCompanyTermItemId?: Maybe<Scalars['UUID']>;
  insuranceNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  motherLastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationalityOther?: Maybe<Scalars['String']>;
  nationalityTermItem?: Maybe<TermItem>;
  nationalityTermItemId?: Maybe<Scalars['UUID']>;
  salutation?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type PurchaseProductInput = {
  paymentMethod: Scalars['String'];
  productCode: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  activeCases?: Maybe<CasesResult>;
  auditLogs?: Maybe<AuditLogsResult>;
  availableDoctors?: Maybe<AvailableDoctorsResult>;
  bioScanHistories?: Maybe<BioScanHistoriesResult>;
  case?: Maybe<Case>;
  caseDoctors?: Maybe<CaseDoctorsResult>;
  caseEntries?: Maybe<CaseEntriesResult>;
  cases?: Maybe<CasesResult>;
  casesAssigned?: Maybe<CasesResult>;
  certificates?: Maybe<CertificatesResult>;
  conversation?: Maybe<Conversation>;
  conversations?: Maybe<ConversationsResult>;
  dashboardLayout?: Maybe<Array<Maybe<DashboardLayoutItem>>>;
  dashboardMessage?: Maybe<Message>;
  dashboardMessages?: Maybe<Array<Maybe<Message>>>;
  dashboardTiles?: Maybe<Array<Maybe<DashboardTile>>>;
  doctors?: Maybe<UsersResult>;
  document?: Maybe<Document>;
  documentVersions?: Maybe<DocumentsResult>;
  documentationFiles?: Maybe<DocumentationFilesResult>;
  documentationFolder?: Maybe<DocumentationFolder>;
  documentationFolders?: Maybe<DocumentationFoldersResult>;
  documents?: Maybe<DocumentsResult>;
  drmaxPickupPlaces?: Maybe<DrMaxPickupPlacesResult>;
  drmaxPrescriptionMedicaments?: Maybe<DrMaxPrescriptionMedicamentsResult>;
  educationMaterial?: Maybe<EducationMaterial>;
  educationMaterialFolders?: Maybe<EducationMaterialFoldersResult>;
  educationMaterials?: Maybe<EducationMaterialsResult>;
  event?: Maybe<Event>;
  events?: Maybe<EventsResult>;
  familyMember?: Maybe<FamilyMember>;
  familyMemberShareList?: Maybe<FamilyMembersResult>;
  familyMembers?: Maybe<FamilyMembersResult>;
  filterCaseContacts?: Maybe<CaseContactsResult>;
  group?: Maybe<Group>;
  groupMembers?: Maybe<GroupMembersResult>;
  groups?: Maybe<GroupsResult>;
  healthData?: Maybe<HealthDataResult>;
  healthDataDashboardCategories?: Maybe<Array<Maybe<HealthDataDashboardCategory>>>;
  healthDataLastValues?: Maybe<HealthDataResult>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanBabyPregnancy?: Maybe<HealthPlanBabyPregnancy>;
  healthPlanUser?: Maybe<HealthPlanUser>;
  healthPlanUserItem?: Maybe<HealthPlanUserItem>;
  healthPlanUserItems?: Maybe<HealthPlanUserItemResult>;
  healthPlanUsers?: Maybe<HealthPlanUsersResult>;
  healthPlans?: Maybe<HealthPlansResult>;
  insuranceOperation?: Maybe<InsuranceOperation>;
  insuranceOperations?: Maybe<InsuranceOperationResult>;
  insuranceReport?: Maybe<InsuranceReport>;
  insuranceReports?: Maybe<InsuranceReportsResult>;
  iots?: Maybe<IotsResult>;
  laboratories?: Maybe<LaboratoryResult>;
  laboratory?: Maybe<Laboratory>;
  laboratoryRequisitionForm?: Maybe<LaboratoryRequisitionFormResult>;
  laboratoryRequisitionResult?: Maybe<LaboratoryRequisitionResult>;
  laboratoryRequisitionResults?: Maybe<LaboratoryRequisitionResultsResult>;
  laboratoryRequisitions?: Maybe<LaboratoryRequisitionsResult>;
  laboratoryWizards?: Maybe<LaboratoryWizardsResult>;
  me?: Maybe<User>;
  meddiAccount?: Maybe<MeddiAccount>;
  meddiAccountTransactions?: Maybe<MeddiAccountTransactionResult>;
  meddiAccounts?: Maybe<MeddiAccountResult>;
  medicalRequestForm?: Maybe<MedicalRequestForm>;
  medicalRequestForms?: Maybe<MedicalRequestFormsResult>;
  message?: Maybe<Message>;
  messageMembers?: Maybe<Array<Maybe<MessageMembersResult>>>;
  messages?: Maybe<MessagesResult>;
  messagesByConversation?: Maybe<MessagesResult>;
  meta?: Maybe<Meta>;
  metaMy?: Maybe<Meta>;
  metas?: Maybe<MetasResult>;
  monitoringCentreCases?: Maybe<CasesResult>;
  myActiveCases?: Maybe<CasesResult>;
  myActiveSubscriptions?: Maybe<UserSubscriptionsResult>;
  myEvents?: Maybe<EventsResult>;
  myFamily?: Maybe<MyFamily>;
  myFamilyMembers?: Maybe<MyFamilyMembersResult>;
  ncziEnumItem?: Maybe<NcziEnumItem>;
  ncziEnumItemByAbbr?: Maybe<NcziEnumItem>;
  ncziEnumItems?: Maybe<NcziEnumItemsByCodeResult>;
  ncziExtensionItem?: Maybe<NcziExtensionItem>;
  ncziExtensionItemByAbbr?: Maybe<NcziExtensionItem>;
  ncziListDiagnosis?: Maybe<NcziDiagnosisItemsResult>;
  ncziListEnumItems?: Maybe<NcziEnumItemsResult>;
  ncziListEnums?: Maybe<NcziEnumsResult>;
  ncziListExtensionItems?: Maybe<NcziExtensionItemsResult>;
  ncziListMedicamentItems?: Maybe<NcziMedicamentItemsResult>;
  ncziListProductItems?: Maybe<NcziProductItemsResult>;
  ncziListQueue?: Maybe<NcziQueueResult>;
  ncziMedicamentItem?: Maybe<NcziMedicamentItem>;
  ncziOUPZsByPZSCode?: Maybe<Array<Maybe<NcziOupZsItem>>>;
  ncziProductItem?: Maybe<NcziProductItem>;
  notifications?: Maybe<MessagesResult>;
  nurseCases?: Maybe<CasesResult>;
  orderStatistics?: Maybe<OrderStatisticsResult>;
  orders?: Maybe<OrdersResult>;
  patient?: Maybe<User>;
  patientCalculators?: Maybe<PatientCalculatorsResult>;
  patients?: Maybe<UsersResult>;
  playlist?: Maybe<Playlist>;
  playlists?: Maybe<PlaylistsResult>;
  posts?: Maybe<PostsResult>;
  prescription?: Maybe<Prescription>;
  prescriptionItems?: Maybe<PrescriptionItemsResult>;
  prescriptionMedicament?: Maybe<PrescriptionMedicament>;
  prescriptionMedicaments?: Maybe<PrescriptionMedicamentsResult>;
  prescriptions?: Maybe<PrescriptionsResult>;
  product?: Maybe<Product>;
  products?: Maybe<Array<Maybe<Product>>>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireResultItems?: Maybe<QuestionnaireResultItemsResult>;
  questionnaireResults?: Maybe<QuestionnaireResultsResult>;
  questionnaireSchedule?: Maybe<QuestionnaireSchedule>;
  questionnaireSchedules?: Maybe<QuestionnaireSchedulesResult>;
  questionnaires?: Maybe<QuestionnairesResult>;
  rating?: Maybe<Rating>;
  ratings?: Maybe<RatingsResult>;
  rootWorkplaceDoctors?: Maybe<WorkplaceMembersResult>;
  rootWorkplacesPatient?: Maybe<WorkplaceMembersResult>;
  serviceSchedules?: Maybe<ServiceSchedulesResult>;
  subscription?: Maybe<Subscription>;
  subscriptionOffers?: Maybe<SubscriptionOffersResult>;
  subscriptionPaymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  subscriptions?: Maybe<SubscriptionsResult>;
  termItem?: Maybe<TermItem>;
  termItemByValue?: Maybe<TermItem>;
  termItems?: Maybe<TermItemsResult>;
  terms?: Maybe<TermsResult>;
  token?: Maybe<Token>;
  tokens?: Maybe<TokensResult>;
  transmiseList?: Maybe<TransmiseListResult>;
  user?: Maybe<User>;
  userConsents?: Maybe<UserConsentsResult>;
  userDekurzes?: Maybe<UserDekurzesResult>;
  userFilter?: Maybe<Meta>;
  userHealthCategories?: Maybe<UserHealthCategoriesResult>;
  userHealthCategoryPermissions?: Maybe<UserHealthCategoryPermissionsResult>;
  userNotice?: Maybe<UserNotice>;
  users?: Maybe<UsersResult>;
  wizard?: Maybe<Wizard>;
  wizardItem?: Maybe<WizardItem>;
  wizardItems?: Maybe<WizardItemsResult>;
  wizardResult?: Maybe<WizardResult>;
  wizardResultItems?: Maybe<WizardResultItemsResult>;
  wizardResults?: Maybe<WizardResultsResult>;
  wizardTree?: Maybe<Array<Maybe<WizardItem>>>;
  wizards?: Maybe<WizardsResult>;
  workplace?: Maybe<Workplace>;
  workplaceAclRoles?: Maybe<AclRoleResult>;
  workplaceAddress?: Maybe<Address>;
  workplaceCaseType?: Maybe<WorkplaceCaseType>;
  workplaceCaseTypes?: Maybe<WorkplaceCaseTypesResult>;
  workplaceCaseTypesDoctor?: Maybe<WorkplaceCaseTypesResult>;
  workplaceCases?: Maybe<CasesResult>;
  workplaceCasesArchived?: Maybe<CasesResult>;
  workplaceDoctors?: Maybe<WorkplaceMembersResult>;
  workplaceEvents?: Maybe<EventsResult>;
  workplaceHealthPlans?: Maybe<HealthPlansResult>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMembers?: Maybe<WorkplaceMembersResult>;
  workplacePatientDocumentationFiles?: Maybe<DocumentationFilesResult>;
  workplacePatientPending?: Maybe<WorkplaceMembersResult>;
  workplacePatients?: Maybe<WorkplaceMembersResult>;
  workplacePresets?: Maybe<Array<Maybe<WorkplacePreset>>>;
  workplaces?: Maybe<WorkplacesResult>;
};


export type QueryActiveCasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
};


export type QueryAuditLogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  targetEntityId?: InputMaybe<Scalars['String']>;
  targetEntityType?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryAvailableDoctorsArgs = {
  nurse: Scalars['Boolean'];
  pagination?: InputMaybe<PaginationInput>;
  pattern: Scalars['String'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryBioScanHistoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCaseArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryCaseDoctorsArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryCaseEntriesArgs = {
  caseId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCasesArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCasesAssignedArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCertificatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryConversationArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryConversationsArgs = {
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<InputMaybe<ConversationType>>>;
};


export type QueryDashboardMessageArgs = {
  userId: Scalars['UUID'];
};


export type QueryDoctorsArgs = {
  excludeRoleKey?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeNurses?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  roleKey?: InputMaybe<Scalars['String']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<DocumentType>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentVersionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryDocumentationFilesArgs = {
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  unprocessed?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentationFolderArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentationFoldersArgs = {
  folderId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDrmaxPickupPlacesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  prescriptionId?: InputMaybe<Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryDrmaxPrescriptionMedicamentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  pharmacyId?: InputMaybe<Scalars['Int']>;
  prescriptionId: Scalars['UUID'];
};


export type QueryEducationMaterialArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryEducationMaterialFoldersArgs = {
  module?: InputMaybe<EducationMaterialModule>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryEducationMaterialsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  module?: InputMaybe<EducationMaterialModule>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryEventArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryEventsArgs = {
  approaching?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  eventMemberId?: InputMaybe<Scalars['UUID']>;
  eventMemberIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  familyView?: InputMaybe<Scalars['Boolean']>;
  future?: InputMaybe<Scalars['Boolean']>;
  metaKey?: InputMaybe<Scalars['String']>;
  metaKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  start?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<InputMaybe<EventType>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryFamilyMemberArgs = {
  where?: InputMaybe<FamilyMemberWhereInput>;
};


export type QueryFamilyMemberShareListArgs = {
  childId?: InputMaybe<Scalars['UUID']>;
};


export type QueryFamilyMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  role?: InputMaybe<FamilyMemberRole>;
};


export type QueryFilterCaseContactsArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryGroupArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryGroupMembersArgs = {
  groupId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGroupsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHealthDataArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  groupId?: InputMaybe<Scalars['String']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  to?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthDataLastValuesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryHealthPlanArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlanBabyPregnancyArgs = {
  patientId: Scalars['UUID'];
};


export type QueryHealthPlanUserArgs = {
  healthPlanCode?: InputMaybe<Scalars['String']>;
  healthPlanId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlanUserItemArgs = {
  healthPlanUserId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryHealthPlanUserItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<HealthPlanUserItemWhereInput>;
};


export type QueryHealthPlanUsersArgs = {
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanCode?: InputMaybe<HealthPlanCodeEnum>;
  pagination?: InputMaybe<PaginationInput>;
  tag?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlansArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryInsuranceOperationArgs = {
  id: Scalars['UUID'];
};


export type QueryInsuranceOperationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: InsuranceOperationsWhereInput;
};


export type QueryInsuranceReportArgs = {
  id: Scalars['UUID'];
};


export type QueryInsuranceReportsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: InsuranceReportsWhereInput;
};


export type QueryIotsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryLaboratoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<LaboratoriesWhereInput>;
};


export type QueryLaboratoryArgs = {
  id: Scalars['UUID'];
};


export type QueryLaboratoryRequisitionFormArgs = {
  where: LaboratoryRequisitionFormWhereInput;
};


export type QueryLaboratoryRequisitionResultArgs = {
  where: LaboratoryRequisitionResultWhereInput;
};


export type QueryLaboratoryRequisitionResultsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryRequisitionResultsWhereInput;
};


export type QueryLaboratoryRequisitionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryRequisitionsWhereInput;
};


export type QueryLaboratoryWizardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<LaboratoryWizardsWhereInput>;
};


export type QueryMeddiAccountArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryMeddiAccountTransactionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MeddiAccountTransactionsWhereInput>;
};


export type QueryMeddiAccountsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MeddiAccountsWhereInput>;
};


export type QueryMedicalRequestFormArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryMedicalRequestFormsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMessageArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryMessageMembersArgs = {
  messageId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMessagesArgs = {
  conversationId?: InputMaybe<Scalars['UUID']>;
  conversationType?: InputMaybe<ConversationType>;
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMessagesByConversationArgs = {
  conversationType?: InputMaybe<ConversationType>;
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMetaMyArgs = {
  key: Scalars['String'];
};


export type QueryMetasArgs = {
  key?: InputMaybe<Scalars['String']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMonitoringCentreCasesArgs = {
  attendingDoctorId?: InputMaybe<Scalars['UUID']>;
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeCode?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<CaseCreateDay>;
  createdAtRange?: InputMaybe<DateFilter>;
  date?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  parentCaseTypeId?: InputMaybe<Scalars['UUID']>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  priorityId?: InputMaybe<Scalars['UUID']>;
  solved?: InputMaybe<Scalars['Boolean']>;
  solvedAtRange?: InputMaybe<DateFilter>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMyActiveCasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMyActiveSubscriptionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<SubscriptionType>;
};


export type QueryMyEventsArgs = {
  approaching?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  start?: InputMaybe<Scalars['DateTime']>;
};


export type QueryNcziEnumItemArgs = {
  code: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziEnumItemByAbbrArgs = {
  abbr: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziEnumItemsArgs = {
  code: Array<Scalars['String']>;
  oid: Scalars['String'];
};


export type QueryNcziExtensionItemArgs = {
  code: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziExtensionItemByAbbrArgs = {
  abbr: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziListDiagnosisArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcziListEnumItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
  version?: InputMaybe<Scalars['String']>;
  withParams?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListExtensionItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
  vaccination?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListMedicamentItemsArgs = {
  antibioticsChemotherapy?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  genericPrescription?: InputMaybe<Scalars['Boolean']>;
  multiplePrescription?: InputMaybe<Scalars['Boolean']>;
  opl?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  vaccination?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListProductItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcziListQueueArgs = {
  userId: Scalars['String'];
};


export type QueryNcziMedicamentItemArgs = {
  code: Scalars['String'];
};


export type QueryNcziOupZsByPzsCodeArgs = {
  pzsCode: Scalars['String'];
};


export type QueryNcziProductItemArgs = {
  code: Scalars['String'];
};


export type QueryNotificationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNurseCasesArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  created?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderStatisticsArgs = {
  where?: InputMaybe<OrderStatisticsWhereInput>;
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrdersFilter>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPatientArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryPatientCalculatorsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPatientsArgs = {
  doctor?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryPlaylistArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryPlaylistsArgs = {
  code?: InputMaybe<PlaylistCode>;
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<PlaylistType>;
};


export type QueryPostsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryPrescriptionArgs = {
  id: Scalars['UUID'];
};


export type QueryPrescriptionItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  prescriptionId?: InputMaybe<Scalars['UUID']>;
};


export type QueryPrescriptionMedicamentArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPrescriptionMedicamentsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  tradeable?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPrescriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryProductArgs = {
  code: Scalars['String'];
};


export type QueryProductsArgs = {
  productGroup: Scalars['String'];
};


export type QueryQuestionnaireArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireResultItemsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  questionKey?: InputMaybe<Scalars['String']>;
  questionKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireResultsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeQuestionnaireCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  hideMemberHidden?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  module?: InputMaybe<QuestionnaireModule>;
  onlyPatient?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  questionnaire?: InputMaybe<Scalars['String']>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<QuestionnaireResultResult>;
  scheduledById?: InputMaybe<Scalars['UUID']>;
  scheduledByIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  seen?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryQuestionnaireScheduleArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireSchedulesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  parentQuestionnaireCode?: InputMaybe<Scalars['String']>;
  parentQuestionnaireScheduleId?: InputMaybe<Scalars['UUID']>;
  questionnaire?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnairesArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  module?: InputMaybe<QuestionnaireModule>;
  parentQuestionnaireId?: InputMaybe<Scalars['UUID']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryRatingArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryRatingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<RatingsWhereInput>;
};


export type QueryRootWorkplaceDoctorsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  includeNurses?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryRootWorkplacesPatientArgs = {
  originalId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryServiceSchedulesArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  includeOccurrences?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  to?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<ServiceScheduleType>;
  types?: InputMaybe<Array<InputMaybe<ServiceScheduleType>>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QuerySubscriptionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  redeemCode?: InputMaybe<Scalars['String']>;
  subscriptionOfferId?: InputMaybe<Scalars['UUID']>;
};


export type QuerySubscriptionOffersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySubscriptionPaymentMethodsArgs = {
  subscriptionOrder?: InputMaybe<PaySubscriptionInput>;
};


export type QuerySubscriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTermItemArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryTermItemByValueArgs = {
  termType: Scalars['String'];
  value: Scalars['String'];
};


export type QueryTermItemsArgs = {
  filter?: InputMaybe<TermItemsFilter>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  termType?: InputMaybe<Scalars['String']>;
};


export type QueryTermsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTokenArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryTokensArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<TokenType>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryTransmiseListArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: TransmiseListWhereInput;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserConsentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<UserConsentsWhereInput>;
};


export type QueryUserDekurzesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserFilterArgs = {
  key: Scalars['String'];
};


export type QueryUserHealthCategoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserHealthCategoryPermissionsArgs = {
  healthCategoryId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  permissionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUsersArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWizardArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardItemArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  wizardKey?: InputMaybe<Scalars['String']>;
};


export type QueryWizardResultArgs = {
  where?: InputMaybe<WizardResultWhereInput>;
};


export type QueryWizardResultItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultItemsWhereInput>;
};


export type QueryWizardResultsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultsWhereInput>;
};


export type QueryWizardTreeArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkplaceArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceAclRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WorkplaceAclRoleWhereInput>;
};


export type QueryWorkplaceAddressArgs = {
  where?: InputMaybe<WorkplaceAddressWhereInput>;
};


export type QueryWorkplaceCaseTypeArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceCaseTypesArgs = {
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  hiddenForPatient?: InputMaybe<Scalars['Boolean']>;
  onlyRootCaseTypes?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  parentCaseTypeId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceCaseTypesDoctorArgs = {
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>>>;
  pagination?: InputMaybe<PaginationInput>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceCasesArgs = {
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctorNull?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceCasesArchivedArgs = {
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  solvedAt?: InputMaybe<CaseSolvedMonth>;
  solvedAtRange?: InputMaybe<DateFilter>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkplaceDoctorsArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanCode?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceEventsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  take?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<InputMaybe<EventType>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceHealthPlansArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryWorkplaceMemberArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceMembersArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplacePatientDocumentationFilesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  unprocessed?: InputMaybe<Scalars['Boolean']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplacePatientPendingArgs = {
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplacePatientsArgs = {
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  insuranceCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  insuranceCompanyName?: InputMaybe<Scalars['String']>;
  insuranceType?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<WorkplacePatientStatus>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplacesArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  hideHidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  managed?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainQuestionnaireId?: Maybe<Scalars['UUID']>;
  module?: Maybe<QuestionnaireModule>;
  partnerId?: Maybe<Scalars['Int']>;
  questionnaireItems?: Maybe<Array<Maybe<QuestionnaireItem>>>;
  settings?: Maybe<Scalars['JSONObject']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type QuestionnaireItem = {
  __typename?: 'QuestionnaireItem';
  childQuestionnaireItems?: Maybe<Array<Maybe<QuestionnaireItem>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  parentQuestionnaireItem?: Maybe<QuestionnaireItem>;
  placeholder?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['ID']>;
  subtitle?: Maybe<Scalars['String']>;
  subtype?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<QuestionnaireItemType>;
  value?: Maybe<Scalars['String']>;
};

export enum QuestionnaireItemSubtype {
  Checkbox = 'CHECKBOX',
  CheckboxList = 'CHECKBOX_LIST',
  Radio = 'RADIO',
  RadioList = 'RADIO_LIST',
  ScaleList = 'SCALE_LIST',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export enum QuestionnaireItemType {
  Answer = 'ANSWER',
  Item = 'ITEM',
  OnSelect = 'ON_SELECT',
  OnSubmit = 'ON_SUBMIT',
  Question = 'QUESTION',
  Rule = 'RULE'
}

export enum QuestionnaireModule {
  Diabetes = 'DIABETES',
  Kdar = 'KDAR',
  Meddibaby = 'MEDDIBABY',
  Oncology = 'ONCOLOGY',
  Palliative = 'PALLIATIVE',
  Therapist = 'THERAPIST'
}

export type QuestionnaireResult = {
  __typename?: 'QuestionnaireResult';
  createdAt?: Maybe<Scalars['DateTime']>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isHidden?: Maybe<Scalars['Boolean']>;
  isSeen?: Maybe<Scalars['Boolean']>;
  isSeenMarkedBy?: Maybe<User>;
  isSeenMarkedById?: Maybe<Scalars['UUID']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  questionnaireResultItems?: Maybe<Array<Maybe<QuestionnaireResultItem>>>;
  result?: Maybe<Scalars['JSONObject']>;
  scheduledBy?: Maybe<User>;
  scheduledById?: Maybe<Scalars['UUID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type QuestionnaireResultItem = {
  __typename?: 'QuestionnaireResultItem';
  answer?: Maybe<QuestionnaireItem>;
  answerId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  question?: Maybe<QuestionnaireItem>;
  questionId?: Maybe<Scalars['UUID']>;
  questionnaireResult?: Maybe<QuestionnaireResult>;
  questionnaireResultId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueJson?: Maybe<Scalars['JSONObject']>;
};

export type QuestionnaireResultItemsResult = {
  __typename?: 'QuestionnaireResultItemsResult';
  data?: Maybe<Array<Maybe<QuestionnaireResultItem>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnaireResultMember = {
  __typename?: 'QuestionnaireResultMember';
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  questionnaireResultId?: Maybe<Scalars['UUID']>;
  seen?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum QuestionnaireResultResult {
  NoRisk = 'NO_RISK',
  NoRiskOfMentalDecompensation = 'NO_RISK_OF_MENTAL_DECOMPENSATION',
  SignificantRisk = 'SIGNIFICANT_RISK',
  SignificantRiskOfMentalDecompensation = 'SIGNIFICANT_RISK_OF_MENTAL_DECOMPENSATION',
  SignificantRiskOfSuicide = 'SIGNIFICANT_RISK_OF_SUICIDE'
}

export type QuestionnaireResultsResult = {
  __typename?: 'QuestionnaireResultsResult';
  data?: Maybe<Array<Maybe<QuestionnaireResult>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnaireSchedule = {
  __typename?: 'QuestionnaireSchedule';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  frequencyText?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  questionnaireItem?: Maybe<QuestionnaireItem>;
  repeatHours?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type QuestionnaireSchedulesResult = {
  __typename?: 'QuestionnaireSchedulesResult';
  data?: Maybe<Array<Maybe<QuestionnaireSchedule>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnairesResult = {
  __typename?: 'QuestionnairesResult';
  data?: Maybe<Array<Maybe<Questionnaire>>>;
  meta?: Maybe<PageInfo>;
};

export type Rating = {
  __typename?: 'Rating';
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  stars?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<RatingType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum RatingType {
  Default = 'DEFAULT',
  Stars = 'STARS'
}

export type RatingsResult = {
  __typename?: 'RatingsResult';
  data?: Maybe<Array<Maybe<Rating>>>;
  meta?: Maybe<PageInfo>;
};

export type RatingsWhereInput = {
  type?: InputMaybe<RatingType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type ReAssignCaseInput = {
  caseId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceMemberId?: InputMaybe<Scalars['UUID']>;
};

export type ReactivateSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  userSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type ReadDashboardMessageInput = {
  messageId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type RemoveHealthPlanWorkplaceInput = {
  healthPlanId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type RemoveUserSubscriptionMemberInput = {
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId?: InputMaybe<Scalars['UUID']>;
};

export type RequestPaymentHealthPlanUserInput = {
  healthPlanUserId: Scalars['UUID'];
};

export type SaveLaboratoryRequisitionResultInput = {
  data: Array<LaboratoryDataInput>;
  document: LaboratoryDocumentInput;
  patient: LaboratoryPatientInput;
  requisitionId: Scalars['UUID'];
  userId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type ServiceSchedule = {
  __typename?: 'ServiceSchedule';
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  serviceScheduleItems?: Maybe<Array<Maybe<ServiceScheduleItem>>>;
  type?: Maybe<ServiceScheduleType>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItem = {
  __typename?: 'ServiceScheduleItem';
  canBook?: Maybe<Scalars['Boolean']>;
  canBookOnSite?: Maybe<Scalars['Boolean']>;
  canBookOnline?: Maybe<Scalars['Boolean']>;
  canOrderImmediate?: Maybe<Scalars['Boolean']>;
  day?: Maybe<DayShortEnum>;
  id: Scalars['UUID'];
  interval?: Maybe<Scalars['Int']>;
  occurrences?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['UUID']>;
  repeatable?: Maybe<Scalars['Boolean']>;
  serviceSchedule?: Maybe<ServiceSchedule>;
  serviceScheduleId?: Maybe<Scalars['UUID']>;
  serviceScheduleItemCaseTypes?: Maybe<Array<Maybe<ServiceScheduleItemCaseType>>>;
  serviceScheduleItemMembers?: Maybe<Array<Maybe<ServiceScheduleItemMember>>>;
  timeFrom?: Maybe<Scalars['Time']>;
  timeTo?: Maybe<Scalars['Time']>;
};


export type ServiceScheduleItemOccurrencesArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceScheduleItemCaseType = {
  __typename?: 'ServiceScheduleItemCaseType';
  id?: Maybe<Scalars['UUID']>;
  serviceScheduleItem?: Maybe<ServiceScheduleItem>;
  serviceScheduleItemId?: Maybe<Scalars['UUID']>;
  workplaceCaseType?: Maybe<WorkplaceCaseType>;
  workplaceCaseTypeId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItemMember = {
  __typename?: 'ServiceScheduleItemMember';
  id?: Maybe<Scalars['UUID']>;
  serviceScheduleItem?: Maybe<ServiceScheduleItem>;
  serviceScheduleItemId?: Maybe<Scalars['UUID']>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMemberId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItemsResult = {
  __typename?: 'ServiceScheduleItemsResult';
  data?: Maybe<Array<Maybe<ServiceScheduleItem>>>;
  meta?: Maybe<PageInfo>;
};

export enum ServiceScheduleType {
  Default = 'DEFAULT',
  OnlineConnect = 'ONLINE_CONNECT',
  OnlineOrder = 'ONLINE_ORDER',
  Shift = 'SHIFT',
  ShiftExtra = 'SHIFT_EXTRA'
}

export type ServiceSchedulesResult = {
  __typename?: 'ServiceSchedulesResult';
  data?: Maybe<Array<Maybe<ServiceSchedule>>>;
  meta?: Maybe<PageInfo>;
};

export type SubmitQuestionnaireResultInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  data?: InputMaybe<Scalars['JSONObject']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  ingestion?: InputMaybe<Scalars['JSONArray']>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  values?: InputMaybe<Array<InputMaybe<SubmitQuestionnaireResultValueInput>>>;
};

export type SubmitQuestionnaireResultValueInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  valueJson?: InputMaybe<Scalars['JSONObject']>;
};

export type SubmitWizardResult = {
  __typename?: 'SubmitWizardResult';
  id?: Maybe<Scalars['UUID']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  descriptionShort?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Scalars['String']>;
  featuredLogo?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFamily?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort?: Maybe<Scalars['String']>;
  redeemCodeRequired?: Maybe<Scalars['Boolean']>;
  subscriptionItems?: Maybe<Array<Maybe<SubscriptionItem>>>;
  subscriptionPeriods?: Maybe<Array<Maybe<SubscriptionPeriod>>>;
  theme?: Maybe<Scalars['String']>;
};

export type SubscriptionGroup = {
  __typename?: 'SubscriptionGroup';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  type: SubscriptionItemType;
};

export enum SubscriptionItemType {
  Acl = 'ACL',
  ActivateSubscriptionRedeemCode = 'ACTIVATE_SUBSCRIPTION_REDEEM_CODE',
  AddMeddiCredit = 'ADD_MEDDI_CREDIT',
  AdultCount = 'ADULT_COUNT',
  AutoSyncFamily = 'AUTO_SYNC_FAMILY',
  BioScanToken = 'BIO_SCAN_TOKEN',
  BioScanTokenRefresh = 'BIO_SCAN_TOKEN_REFRESH',
  BioScanTokenUnlimited = 'BIO_SCAN_TOKEN_UNLIMITED',
  CaseWorkplaceDoctor = 'CASE_WORKPLACE_DOCTOR',
  ChildCount = 'CHILD_COUNT',
  ConnectDoctor = 'CONNECT_DOCTOR',
  CreateCaseImmediatePay = 'CREATE_CASE_IMMEDIATE_PAY',
  CreateCaseWizard = 'CREATE_CASE_WIZARD',
  CreateWorkplaceMember = 'CREATE_WORKPLACE_MEMBER',
  Description = 'DESCRIPTION',
  EmailVerified = 'EMAIL_VERIFIED',
  FamilyAddChild = 'FAMILY_ADD_CHILD',
  FirstMonthFree = 'FIRST_MONTH_FREE',
  HealthPlanFree = 'HEALTH_PLAN_FREE',
  ImmediatePayCustom = 'IMMEDIATE_PAY_CUSTOM',
  ImmediatePayFreeSubscription = 'IMMEDIATE_PAY_FREE_SUBSCRIPTION',
  IsFamily = 'IS_FAMILY',
  ProductBioscanToken = 'PRODUCT_BIOSCAN_TOKEN',
  ProductBioscanTokenSale = 'PRODUCT_BIOSCAN_TOKEN_SALE',
  RemoveProduct = 'REMOVE_PRODUCT',
  SetPartner = 'SET_PARTNER',
  SkipCanCreateCase = 'SKIP_CAN_CREATE_CASE',
  SubscriptionAvailability = 'SUBSCRIPTION_AVAILABILITY',
  SubscriptionSale = 'SUBSCRIPTION_SALE',
  WellbeingConnectDoctorToken = 'WELLBEING_CONNECT_DOCTOR_TOKEN'
}

export type SubscriptionOffer = {
  __typename?: 'SubscriptionOffer';
  description?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['UUID']>;
  imageUrl?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  priceSale?: Maybe<Price>;
  priceSuffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<SubscriptionOfferType>;
};

export enum SubscriptionOfferType {
  BioScan = 'BIO_SCAN',
  Subscription = 'SUBSCRIPTION'
}

export type SubscriptionOffersResult = {
  __typename?: 'SubscriptionOffersResult';
  data?: Maybe<Array<Maybe<SubscriptionOffer>>>;
  meta?: Maybe<PageInfo>;
};

export type SubscriptionOrder = {
  __typename?: 'SubscriptionOrder';
  redirectUrl?: Maybe<Scalars['String']>;
};

export type SubscriptionPeriod = {
  __typename?: 'SubscriptionPeriod';
  discount?: Maybe<PriceDiscount>;
  id: Scalars['ID'];
  period?: Maybe<Scalars['Int']>;
  price?: Maybe<Price>;
  type: SubscriptionPeriodType;
};

export enum SubscriptionPeriodType {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Unlimited = 'UNLIMITED',
  UntilDate = 'UNTIL_DATE',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type SubscriptionRedeemCode = {
  __typename?: 'SubscriptionRedeemCode';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['UUID']>;
};

export enum SubscriptionType {
  RedeemCode = 'REDEEM_CODE',
  Subscription = 'SUBSCRIPTION'
}

export type SubscriptionsResult = {
  __typename?: 'SubscriptionsResult';
  data?: Maybe<Array<Maybe<Subscription>>>;
  meta?: Maybe<PageInfo>;
};

export type SyncStatus = {
  __typename?: 'SyncStatus';
  createdAt?: Maybe<Scalars['DateTime']>;
  resourceType?: Maybe<Scalars['String']>;
  state?: Maybe<SyncStatusState>;
};

export enum SyncStatusState {
  Error = 'ERROR',
  Finished = 'FINISHED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type Term = {
  __typename?: 'Term';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  type?: Maybe<Scalars['String']>;
};

export type TermItem = {
  __typename?: 'TermItem';
  data?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  term?: Maybe<Term>;
  termId?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
  value2?: Maybe<Scalars['String']>;
  value3?: Maybe<Scalars['String']>;
};

export type TermItemsFilter = {
  value2?: InputMaybe<Scalars['String']>;
};

export type TermItemsResult = {
  __typename?: 'TermItemsResult';
  data?: Maybe<Array<Maybe<TermItem>>>;
  meta?: Maybe<PageInfo>;
};

export type TermsResult = {
  __typename?: 'TermsResult';
  data?: Maybe<Array<Maybe<Term>>>;
  meta?: Maybe<PageInfo>;
};

export enum ThemeEnum {
  Blue = 'blue',
  Bronze = 'bronze',
  Orange = 'orange'
}

export type Token = {
  __typename?: 'Token';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<TokenType>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum TokenType {
  Api = 'API',
  EmailVerification = 'EMAIL_VERIFICATION',
  Ingestion = 'INGESTION'
}

export type TokensResult = {
  __typename?: 'TokensResult';
  data?: Maybe<Array<Maybe<Token>>>;
  meta?: Maybe<PageInfo>;
};

export type TransactionOrder = {
  __typename?: 'TransactionOrder';
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  issueDate?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Array<Maybe<TransactionOrderItem>>>;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  status?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<TransactionPrice>;
};

export type TransactionOrderItem = {
  __typename?: 'TransactionOrderItem';
  price?: Maybe<TransactionPrice>;
  priceVat?: Maybe<TransactionPrice>;
  priceWithoutVat?: Maybe<TransactionPrice>;
  quantity?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type TransactionPrice = {
  __typename?: 'TransactionPrice';
  currency?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  formattedPrice?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  priceWithVat?: Maybe<Scalars['Decimal']>;
  priceWithVatRaw?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  vatRate?: Maybe<Scalars['Int']>;
};

export type Translation = {
  __typename?: 'Translation';
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type TransmiseDocument = {
  __typename?: 'TransmiseDocument';
  date?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  workplace?: Maybe<Scalars['String']>;
};

export type TransmiseListResult = {
  __typename?: 'TransmiseListResult';
  data?: Maybe<Array<Maybe<TransmiseDocument>>>;
  meta?: Maybe<PageInfo>;
};

export type TransmiseListWhereInput = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  doctorId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateDocumentationFolderInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateNoteInput = {
  id: Scalars['UUID'];
  text: Scalars['String'];
};

export type UpdateUserConsentInput = {
  value: UserConsentValue;
};

export type UpdateWorkplaceMemberInput = {
  id?: InputMaybe<Scalars['UUID']>;
  isSpecialist?: InputMaybe<Scalars['Boolean']>;
  memberSearchableOutside?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateWorkplaceMembersInput = {
  workplaceMembers?: InputMaybe<Array<InputMaybe<UpdateWorkplaceMemberInput>>>;
};

export type User = {
  __typename?: 'User';
  approved?: Maybe<Scalars['Boolean']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  avatarFile?: Maybe<File>;
  avatarUrl?: Maybe<Scalars['String']>;
  badge?: Maybe<Badge>;
  certificates?: Maybe<Array<Maybe<Certificate>>>;
  consentProvider?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  csszResult?: Maybe<Scalars['JSONObject']>;
  details?: Maybe<UserDetails>;
  email?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<Event>>>;
  expiredSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  firstLogin?: Maybe<Scalars['Boolean']>;
  formattedGender?: Maybe<Scalars['String']>;
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasMeddi?: Maybe<Scalars['Boolean']>;
  healthCard?: Maybe<HealthCard>;
  id: Scalars['ID'];
  ingestionUrl?: Maybe<Scalars['String']>;
  insuranceCardBackThumbnailUrl?: Maybe<Scalars['String']>;
  insuranceCardBackUrl?: Maybe<Scalars['String']>;
  insuranceCardFrontThumbnailUrl?: Maybe<Scalars['String']>;
  insuranceCardFrontUrl?: Maybe<Scalars['String']>;
  invitations?: Maybe<Array<Maybe<UserInvitation>>>;
  isChild?: Maybe<Scalars['Boolean']>;
  isDoctor?: Maybe<Scalars['Boolean']>;
  isPatient?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  localCitizenship?: Maybe<Scalars['Boolean']>;
  memberOf?: Maybe<Array<Maybe<Badge>>>;
  memberOfDoctor?: Maybe<Array<Maybe<Badge>>>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  metaTranslation?: Maybe<Array<Maybe<MetaTranslation>>>;
  note?: Maybe<Scalars['String']>;
  originalId?: Maybe<Scalars['UUID']>;
  originalUser?: Maybe<User>;
  parents?: Maybe<Array<Maybe<User>>>;
  partner?: Maybe<Scalars['String']>;
  partnerIdentifier?: Maybe<Scalars['String']>;
  partnerTag?: Maybe<UserPartnerTag>;
  phoneNumber?: Maybe<Scalars['String']>;
  profile?: Maybe<Profile>;
  profileImageUrl?: Maybe<Scalars['String']>;
  rootWorkplace?: Maybe<Workplace>;
  rootWorkplaceMemberStatus?: Maybe<Scalars['String']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  userConsent?: Maybe<UserConsent>;
  userNumber?: Maybe<UserNumber>;
  userRating?: Maybe<UserRating>;
  userRelations?: Maybe<Array<Maybe<UserRelation>>>;
  vzpRegisteredDoctorsResult?: Maybe<Scalars['JSONObject']>;
  vzpResult?: Maybe<Scalars['JSONObject']>;
  workplace?: Maybe<Workplace>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
};


export type UserEventsArgs = {
  metaKey?: InputMaybe<Scalars['String']>;
  metaKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type UserMetaArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type UserMetaTranslationArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UserUserNumberArgs = {
  by?: InputMaybe<UserNumberBy>;
};


export type UserUserRelationsArgs = {
  type?: InputMaybe<UserRelationType>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type UserWorkplaceMemberArgs = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UserConsent = {
  __typename?: 'UserConsent';
  canceledAt?: Maybe<Scalars['DateTime']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  documentationFile?: Maybe<DocumentationFile>;
  extra?: Maybe<Scalars['JSON']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  type: UserConsentType;
  userId: Scalars['UUID'];
  value: UserConsentValue;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum UserConsentType {
  InformedConsent = 'INFORMED_CONSENT'
}

export enum UserConsentValue {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Sent = 'SENT'
}

export type UserConsentsResult = {
  __typename?: 'UserConsentsResult';
  data?: Maybe<Array<Maybe<UserConsent>>>;
  meta?: Maybe<PageInfo>;
};

export type UserConsentsWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<UserConsentType>;
  userId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UserDekurz = {
  __typename?: 'UserDekurz';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userDekurzItems?: Maybe<Array<Maybe<UserDekurzItem>>>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type UserDekurzItem = {
  __typename?: 'UserDekurzItem';
  id: Scalars['UUID'];
  medicalReport?: Maybe<MedicalReport>;
  medicalReportId?: Maybe<Scalars['UUID']>;
  type?: Maybe<UserDekurzItemType>;
  userDekurz?: Maybe<UserDekurz>;
  userDekurzId?: Maybe<Scalars['UUID']>;
};

export enum UserDekurzItemType {
  MedicalReport = 'MEDICAL_REPORT'
}

export type UserDekurzesResult = {
  __typename?: 'UserDekurzesResult';
  data?: Maybe<Array<Maybe<UserDekurz>>>;
  meta?: Maybe<PageInfo>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserFilterInput = {
  data: Scalars['JSONObject'];
  key: Scalars['String'];
};

export type UserHealthCategoriesResult = {
  __typename?: 'UserHealthCategoriesResult';
  data?: Maybe<Array<Maybe<UserHealthCategory>>>;
  meta?: Maybe<PageInfo>;
};

export type UserHealthCategory = {
  __typename?: 'UserHealthCategory';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UserHealthCategoryPermission = {
  __typename?: 'UserHealthCategoryPermission';
  healthCategory?: Maybe<UserHealthCategory>;
  healthCategoryId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  permission?: Maybe<TermItem>;
  permissionId?: Maybe<Scalars['UUID']>;
};

export type UserHealthCategoryPermissionInput = {
  healthCategoryId?: InputMaybe<Scalars['UUID']>;
  permissionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type UserHealthCategoryPermissionsResult = {
  __typename?: 'UserHealthCategoryPermissionsResult';
  data?: Maybe<Array<Maybe<UserHealthCategoryPermission>>>;
  meta?: Maybe<PageInfo>;
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  declinedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<UserInvitationStatus>;
  used?: Maybe<Scalars['Boolean']>;
};

export enum UserInvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type UserMetaTranslationInput = {
  key?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UserNotice = {
  __typename?: 'UserNotice';
  activeCasesCount?: Maybe<Scalars['Int']>;
  futureEventsCount?: Maybe<Scalars['Int']>;
  openQuestionnairesCount?: Maybe<Scalars['Int']>;
  unreadCaseEntries?: Maybe<Scalars['Int']>;
  unreadEducationMaterialsCount?: Maybe<Scalars['Int']>;
  unreadNotifications?: Maybe<Scalars['Int']>;
  unreadPrescriptions?: Maybe<Scalars['Int']>;
};

export type UserNumber = {
  __typename?: 'UserNumber';
  birthNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum UserNumberBy {
  BirthNumber = 'BIRTH_NUMBER',
  Number = 'NUMBER'
}

export type UserPartnerTag = {
  __typename?: 'UserPartnerTag';
  title?: Maybe<Scalars['String']>;
};

export type UserRating = {
  __typename?: 'UserRating';
  avgStar?: Maybe<Scalars['Float']>;
};

export type UserRelation = {
  __typename?: 'UserRelation';
  id?: Maybe<Scalars['Int']>;
  relationUser?: Maybe<User>;
  relationUserId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum UserRelationType {
  PatientDoctor = 'PATIENT_DOCTOR'
}

export type UserSubscription = {
  __typename?: 'UserSubscription';
  activeFrom: Scalars['DateTime'];
  activeTo?: Maybe<Scalars['DateTime']>;
  availability?: Maybe<UserSubscriptionAvailability>;
  canAddMember?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isOwner?: Maybe<Scalars['Boolean']>;
  members?: Maybe<Array<Maybe<UserSubscriptionMember>>>;
  price?: Maybe<Price>;
  redeemCode?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  subscriptionPeriod?: Maybe<SubscriptionPeriod>;
};

export type UserSubscriptionAvailability = {
  __typename?: 'UserSubscriptionAvailability';
  addAdultMember?: Maybe<Scalars['Boolean']>;
  addChildMember?: Maybe<Scalars['Boolean']>;
  addMember?: Maybe<Scalars['Boolean']>;
  manage?: Maybe<Scalars['Boolean']>;
};

export type UserSubscriptionCancelInput = {
  id: Scalars['UUID'];
};

export type UserSubscriptionMember = {
  __typename?: 'UserSubscriptionMember';
  id: Scalars['ID'];
  isOwner?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  userSubscription?: Maybe<UserSubscription>;
  userSubscriptionId?: Maybe<Scalars['UUID']>;
};

export type UserSubscriptionsResult = {
  __typename?: 'UserSubscriptionsResult';
  data?: Maybe<Array<Maybe<UserSubscription>>>;
  meta?: Maybe<PageInfo>;
};

export type UsersResult = {
  __typename?: 'UsersResult';
  data?: Maybe<Array<Maybe<User>>>;
  meta?: Maybe<PageInfo>;
};

export type Wizard = {
  __typename?: 'Wizard';
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  wizardItems?: Maybe<Array<Maybe<WizardItem>>>;
};

export type WizardItem = {
  __typename?: 'WizardItem';
  childWizardItems?: Maybe<Array<Maybe<WizardItem>>>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  parentWizardItem?: Maybe<WizardItem>;
  parentWizardItemId?: Maybe<Scalars['UUID']>;
  rank?: Maybe<Scalars['Int']>;
  settings?: Maybe<Scalars['JSONObject']>;
  wizard?: Maybe<Wizard>;
  wizardId?: Maybe<Scalars['UUID']>;
};

export type WizardItemsResult = {
  __typename?: 'WizardItemsResult';
  data?: Maybe<Array<Maybe<WizardItem>>>;
  meta?: Maybe<PageInfo>;
};

export type WizardResult = {
  __typename?: 'WizardResult';
  createdAt: Scalars['DateTime'];
  hidden: Scalars['Boolean'];
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  wizard?: Maybe<Wizard>;
  wizardId: Scalars['UUID'];
  wizardResultItems: Array<WizardResultItem>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type WizardResultWizardResultItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultItemsWhereInput>;
};

export type WizardResultInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  caseId?: InputMaybe<Scalars['UUID']>;
  items?: InputMaybe<Array<InputMaybe<WizardResultItemInput>>>;
  userId: Scalars['UUID'];
  wizardId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
};

export type WizardResultItem = {
  __typename?: 'WizardResultItem';
  createdAt: Scalars['DateTime'];
  formattedValue?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSONObject']>;
  wizardResult: WizardResult;
  wizardResultId: Scalars['UUID'];
};

export type WizardResultItemInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  wizardItemId: Scalars['UUID'];
};

export type WizardResultItemsResult = {
  __typename?: 'WizardResultItemsResult';
  data?: Maybe<Array<Maybe<WizardResultItem>>>;
  meta?: Maybe<PageInfo>;
};

export type WizardResultItemsWhereInput = {
  showSystemKeys?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
  wizardResultId?: InputMaybe<Scalars['UUID']>;
};

export type WizardResultWhereInput = {
  id: Scalars['UUID'];
};

export type WizardResultsResult = {
  __typename?: 'WizardResultsResult';
  data?: Maybe<Array<Maybe<WizardResult>>>;
  meta?: Maybe<PageInfo>;
  settings?: Maybe<Scalars['JSONObject']>;
};

export type WizardResultsWhereInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  wizardId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WizardsResult = {
  __typename?: 'WizardsResult';
  data?: Maybe<Array<Maybe<Wizard>>>;
  meta?: Maybe<PageInfo>;
};

export type Workplace = {
  __typename?: 'Workplace';
  address?: Maybe<Address>;
  approved?: Maybe<Scalars['Boolean']>;
  billingAddress?: Maybe<Address>;
  calendarEmailNotification?: Maybe<Scalars['Boolean']>;
  caseDoctorDescription?: Maybe<Scalars['String']>;
  codeName?: Maybe<Scalars['String']>;
  createCaseTarget?: Maybe<CreateCaseTarget>;
  doctorDisplayName?: Maybe<Scalars['String']>;
  firstSetup?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  memberSearchableOutside?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  metaSuklCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentWorkplace?: Maybe<Workplace>;
  parentWorkplaceId?: Maybe<Scalars['UUID']>;
  partnerId?: Maybe<Scalars['String']>;
  patientDisplayName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rootBilling?: Maybe<Scalars['Boolean']>;
  rootWorkplace?: Maybe<Workplace>;
  rootWorkplaceId?: Maybe<Scalars['UUID']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  workplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
  workplaceSearchableOutside?: Maybe<Scalars['Boolean']>;
};


export type WorkplaceMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export type WorkplaceAddressWhereInput = {
  type: AddressType;
  workplaceId: Scalars['UUID'];
};

export type WorkplaceCaseType = {
  __typename?: 'WorkplaceCaseType';
  canSearchDoctor?: Maybe<Scalars['Boolean']>;
  canSelectTransport?: Maybe<Scalars['Boolean']>;
  canSendToAmbulance?: Maybe<Scalars['Boolean']>;
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  labelTranslations?: Maybe<Array<Maybe<Translation>>>;
  workplace?: Maybe<Workplace>;
  workplaceDefaultCaseType?: Maybe<Scalars['Boolean']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type WorkplaceCaseTypesResult = {
  __typename?: 'WorkplaceCaseTypesResult';
  data?: Maybe<Array<Maybe<WorkplaceCaseType>>>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceMember = {
  __typename?: 'WorkplaceMember';
  archivedAt?: Maybe<Scalars['DateTime']>;
  archivedBy?: Maybe<User>;
  archivedById?: Maybe<Scalars['UUID']>;
  archivedReason?: Maybe<TermItem>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  dateOfDeath?: Maybe<Scalars['Date']>;
  hasShiftNow?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isSpecialist?: Maybe<Scalars['Boolean']>;
  memberSearchableOutside?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  userRelation?: Maybe<UserRelation>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['ID']>;
  workplaceMemberRoles?: Maybe<Array<Maybe<WorkplaceMemberRole>>>;
};


export type WorkplaceMemberMetaArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type WorkplaceMemberUserRelationArgs = {
  type?: InputMaybe<UserRelationType>;
};

export type WorkplaceMemberRole = {
  __typename?: 'WorkplaceMemberRole';
  id: Scalars['ID'];
  role?: Maybe<AclRole>;
  roleId: Scalars['ID'];
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMemberId: Scalars['ID'];
};

export type WorkplaceMembersResult = {
  __typename?: 'WorkplaceMembersResult';
  data?: Maybe<Array<Maybe<WorkplaceMember>>>;
  meta?: Maybe<PageInfo>;
};

export enum WorkplacePatientStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  ArchivedByPatient = 'ARCHIVED_BY_PATIENT',
  ArchivedByWorkplace = 'ARCHIVED_BY_WORKPLACE',
  Declined = 'DECLINED',
  HealthPlanActive = 'HEALTH_PLAN_ACTIVE',
  HealthPlanCreated = 'HEALTH_PLAN_CREATED',
  HealthPlanNotPaid = 'HEALTH_PLAN_NOT_PAID',
  Pending = 'PENDING',
  Virtual = 'VIRTUAL'
}

export type WorkplacePreset = {
  __typename?: 'WorkplacePreset';
  id?: Maybe<Scalars['UUID']>;
  memberType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum WorkplacePresetMemberType {
  Child = 'CHILD',
  Patient = 'PATIENT'
}

export enum WorkplacePresetType {
  Pediatr = 'PEDIATR',
  Praktik = 'PRAKTIK',
  Terapeut = 'TERAPEUT',
  Zubar = 'ZUBAR'
}

export type WorkplacesResult = {
  __typename?: 'WorkplacesResult';
  data?: Maybe<Array<Maybe<Workplace>>>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceAclRoleWhereInput = {
  excludeRoleKeys?: InputMaybe<Array<InputMaybe<AclRoleKey>>>;
};

export type TermItemsQueryVariables = Exact<{
  termType?: InputMaybe<Scalars['String']>;
  fullText?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TermItemsFilter>;
  take?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TermItemsQuery = { __typename?: 'Query', termItems?: { __typename?: 'TermItemsResult', data?: Array<{ __typename?: 'TermItem', id: string, termId?: string | null, name?: string | null, value?: string | null, value2?: string | null, value3?: string | null, data?: any | null } | null> | null } | null };

export type FilterCaseContactsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  caseTypeCode?: InputMaybe<Scalars['String']>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FilterCaseContactsQuery = { __typename?: 'Query', filterCaseContacts?: { __typename?: 'CaseContactsResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'CaseContact', userId?: string | null, workplaceMemberId?: string | null, workplaceId?: string | null, textRow1?: string | null, textRow2?: string | null, textRow3?: string | null, type?: CaseContactType | null, iconUrl?: string | null, workplaceMemberUserRelation?: { __typename?: 'UserRelation', id?: number | null, userId?: any | null, user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null } | null> | null } | null };

export type CaseCreateUsersQueryVariables = Exact<{
  userIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type CaseCreateUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersResult', data?: Array<{ __typename?: 'User', id: string, profileImageUrl?: string | null, isChild?: boolean | null, profile?: { __typename?: 'Profile', firstName?: string | null, lastName?: string | null, fullName?: string | null } | null } | null> | null } | null };

export type DashboardMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardMessagesQuery = { __typename?: 'Query', dashboardMessages?: Array<{ __typename?: 'Message', id: any, content?: any | null, type?: string | null, sender?: { __typename?: 'MessageMember', user?: { __typename?: 'User', profileImageUrl?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null } | null } | null> | null };

export type ReadDashboardMessageMutationVariables = Exact<{
  input?: InputMaybe<ReadDashboardMessageInput>;
}>;


export type ReadDashboardMessageMutation = { __typename?: 'Mutation', readDashboardMessage?: { __typename?: 'Message', id: any } | null };

export type DocumentationFilesQueryVariables = Exact<{
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
}>;


export type DocumentationFilesQuery = { __typename?: 'Query', documentationFiles?: { __typename?: 'DocumentationFilesResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'DocumentationFile', id: any, name?: string | null, extension?: string | null, displayName?: string | null, folderId?: any | null, hasThumb?: boolean | null, userId?: any | null, thumbUrl?: string | null, avResult?: string | null, createdAt?: any | null, file?: { __typename?: 'File', id: any, name?: string | null, extension?: string | null } | null, createdBy?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, workplace?: { __typename?: 'Workplace', id: string, name?: string | null } | null, fileTransfers?: { __typename?: 'Meta', value?: any | null } | null } | null> | null } | null };

export type CreateDrMaxPrescriptionReservationMutationVariables = Exact<{
  input?: InputMaybe<CreateDrMaxPrescriptionReservationInput>;
}>;


export type CreateDrMaxPrescriptionReservationMutation = { __typename?: 'Mutation', createDrMaxPrescriptionReservation?: { __typename?: 'DrMaxPrescriptionReservation', incrementId?: string | null } | null };

export type GetDrMaxPickupPlacesQueryVariables = Exact<{
  prescriptionId?: InputMaybe<Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetDrMaxPickupPlacesQuery = { __typename?: 'Query', drmaxPickupPlaces?: { __typename?: 'DrMaxPickupPlacesResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'DrMaxPickupPlace', id?: any | null, name?: string | null, isOpen?: boolean | null, distanceFormatted?: string | null, productsInStock?: Array<{ __typename?: 'DrMaxProductsInStock', name?: string | null, inStock?: boolean | null } | null> | null, openingHours?: Array<{ __typename?: 'DrMaxOpeningHourItem', date?: any | null, open?: boolean | null, nonstop?: boolean | null, hours?: Array<{ __typename?: 'DrMaxOpeningHour', to?: any | null, from?: any | null, note?: string | null, open?: boolean | null } | null> | null } | null> | null } | null> | null } | null };

export type GetDrMaxPrescriptionMedicamentsQueryVariables = Exact<{
  prescriptionId: Scalars['UUID'];
  drmaxPickupPlaceId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetDrMaxPrescriptionMedicamentsQuery = { __typename?: 'Query', drmaxPrescriptionMedicaments?: { __typename?: 'DrMaxPrescriptionMedicamentsResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'DrMaxPrescriptionMedicament', name?: string | null, formattedApproximatePrice?: string | null, inStock?: boolean | null } | null> | null } | null };

export type GetPrescriptionQueryVariables = Exact<{
  prescriptionId: Scalars['UUID'];
}>;


export type GetPrescriptionQuery = { __typename?: 'Query', prescription?: { __typename?: 'Prescription', drMaxPickupPlace?: { __typename?: 'DrMaxPickupPlace', openingHours?: Array<{ __typename?: 'DrMaxOpeningHourItem', date?: any | null, open?: boolean | null, nonstop?: boolean | null, hours?: Array<{ __typename?: 'DrMaxOpeningHour', to?: any | null, from?: any | null, note?: string | null, open?: boolean | null } | null> | null } | null> | null } | null } | null };

export type FamilyMemberRelationMutationVariables = Exact<{
  input?: InputMaybe<FamilyMemberRelationInput>;
}>;


export type FamilyMemberRelationMutation = { __typename?: 'Mutation', familyMemberRelation?: { __typename?: 'FamilyMember', userId: any } | null };

export type GetFamilyMemberShareListQueryVariables = Exact<{
  childId: Scalars['UUID'];
}>;


export type GetFamilyMemberShareListQuery = { __typename?: 'Query', familyMemberShareList?: { __typename?: 'FamilyMembersResult', meta?: { __typename?: 'PageInfo', count?: number | null } | null, data?: Array<{ __typename?: 'FamilyMember', userId: any, role: FamilyMemberRole, user: { __typename?: 'User', profileImageUrl?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null } | null } } | null> | null } | null };

export type GetFamilyMembersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  role?: InputMaybe<FamilyMemberRole>;
}>;


export type GetFamilyMembersQuery = { __typename?: 'Query', familyMembers?: { __typename?: 'FamilyMembersResult', data?: Array<{ __typename?: 'FamilyMember', userId: any, role: FamilyMemberRole, user: { __typename?: 'User', profileImageUrl?: string | null, profile?: { __typename?: 'Profile', fullName?: string | null } | null } } | null> | null } | null };

export type UpdateUserConsentMutationVariables = Exact<{
  where?: InputMaybe<UserConsentsWhereInput>;
  data?: InputMaybe<UpdateUserConsentInput>;
}>;


export type UpdateUserConsentMutation = { __typename?: 'Mutation', updateUserConsent?: { __typename?: 'UserConsent', id: any } | null };

export type UserConsentsQueryVariables = Exact<{
  where?: InputMaybe<UserConsentsWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type UserConsentsQuery = { __typename?: 'Query', userConsents?: { __typename?: 'UserConsentsResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'UserConsent', id: any, type: UserConsentType, userId: any, name: string, createdAt: any, confirmedAt?: any | null, canceledAt?: any | null, value: UserConsentValue, workplace?: { __typename?: 'Workplace', name?: string | null, address?: { __typename?: 'Address', fullAddress?: string | null } | null } | null, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null } | null } | null, documentationFile?: { __typename?: 'DocumentationFile', id: any, userId?: any | null, folderId?: any | null, name?: string | null, file?: { __typename?: 'File', id: any, extension?: string | null } | null } | null } | null> | null } | null };

export type MeasurementHistoryQueryVariables = Exact<{
  where?: InputMaybe<WizardResultsWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type MeasurementHistoryQuery = { __typename?: 'Query', wizardResults?: { __typename?: 'WizardResultsResult', settings?: any | null, meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'WizardResult', id: any, createdAt: any, wizardResultItems: Array<{ __typename?: 'WizardResultItem', id: any, key: string, value?: any | null, formattedValue?: string | null, label?: string | null }> } | null> | null } | null };

export type RemoveMeasurementHistoryItemMutationVariables = Exact<{
  input: DeleteWizardResultInput;
}>;


export type RemoveMeasurementHistoryItemMutation = { __typename?: 'Mutation', deleteWizardResult?: { __typename?: 'MutationResult', status?: boolean | null } | null };

export type ReactivateExpiredSubscriptionMutationVariables = Exact<{
  input?: InputMaybe<ReactivateSubscriptionInput>;
}>;


export type ReactivateExpiredSubscriptionMutation = { __typename?: 'Mutation', reactivateExpiredSubscription?: { __typename?: 'SubscriptionOrder', redirectUrl?: string | null } | null };

export type SubscriptionPaymentMethodQueryVariables = Exact<{
  input?: InputMaybe<PaySubscriptionInput>;
}>;


export type SubscriptionPaymentMethodQuery = { __typename?: 'Query', subscriptionPaymentMethods?: Array<{ __typename?: 'PaymentMethod', title?: string | null, icon?: string | null, type?: string | null } | null> | null };

export type TryChargeExpiredSubscriptionMutationVariables = Exact<{
  input?: InputMaybe<ChargeSubscriptionInput>;
}>;


export type TryChargeExpiredSubscriptionMutation = { __typename?: 'Mutation', tryChargeExpiredSubscription?: { __typename?: 'ChargeStatus', success?: boolean | null, message?: string | null } | null };

export type UserExpiredSubscriptionsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type UserExpiredSubscriptionsQuery = { __typename?: 'Query', user?: { __typename?: 'User', expiredSubscriptions?: Array<{ __typename?: 'UserSubscription', id: string, subscription?: { __typename?: 'Subscription', id: string } | null, subscriptionPeriod?: { __typename?: 'SubscriptionPeriod', id: string } | null } | null> | null } | null };

export type UserSubscriptionCancelMutationVariables = Exact<{
  input?: InputMaybe<UserSubscriptionCancelInput>;
}>;


export type UserSubscriptionCancelMutation = { __typename?: 'Mutation', userSubscriptionCancel?: { __typename?: 'MutationResult', status?: boolean | null } | null };

export type FamilyMemberInvitationDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type FamilyMemberInvitationDetailQuery = { __typename?: 'Query', user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string | null, birthDate?: string | null, birthNumber?: string | null, address?: { __typename?: 'Address', formattedFullAddress?: string | null } | null, insuranceCompanyTermItem?: { __typename?: 'TermItem', value?: string | null, value2?: string | null } | null } | null } | null };

export type FamilyMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type FamilyMembersQuery = { __typename?: 'Query', familyMembers?: { __typename?: 'FamilyMembersResult', data?: Array<{ __typename?: 'FamilyMember', id: number, role: FamilyMemberRole, user: { __typename?: 'User', id: string, profileImageUrl?: string | null, email?: string | null, profile?: { __typename?: 'Profile', firstName?: string | null } | null } } | null> | null } | null };

export type FamilyMemberQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type FamilyMemberQuery = { __typename?: 'Query', familyMember?: { __typename?: 'FamilyMember', canBeDeleted: boolean, canBeShared: boolean } | null };

export type SimpleUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type SimpleUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', profileImageUrl?: string | null, profile?: { __typename?: 'Profile', firstName?: string | null } | null } | null };

export type CreateRatingMutationVariables = Exact<{
  input?: InputMaybe<CreateRatingInput>;
}>;


export type CreateRatingMutation = { __typename?: 'Mutation', createRating?: { __typename?: 'Rating', id: any } | null };

export type ActivateRedeemCodeMutationVariables = Exact<{
  input?: InputMaybe<ActivateUserSubscriptionByRedeemCode>;
}>;


export type ActivateRedeemCodeMutation = { __typename?: 'Mutation', activateUserSubscriptionByRedeemCode?: { __typename?: 'UserSubscription', id: string } | null };

export type MeddiAccountTransactionsQueryVariables = Exact<{
  where?: InputMaybe<MeddiAccountTransactionsWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MeddiAccountTransactionsQuery = { __typename?: 'Query', meddiAccountTransactions?: { __typename?: 'MeddiAccountTransactionResult', data?: Array<{ __typename?: 'MeddiTransaction', id?: any | null, type?: string | null, amount?: number | null, orderId?: any | null, order?: { __typename?: 'TransactionOrder', id?: string | null, issueDate?: any | null, status?: string | null, items?: Array<{ __typename?: 'TransactionOrderItem', title?: string | null, unit?: string | null, quantity?: number | null } | null> | null } | null } | null> | null, meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null } | null } | null };

export type MeddiAccountsQueryVariables = Exact<{
  where?: InputMaybe<MeddiAccountsWhereInput>;
}>;


export type MeddiAccountsQuery = { __typename?: 'Query', meddiAccounts?: { __typename?: 'MeddiAccountResult', data?: Array<{ __typename?: 'MeddiAccount', balance?: number | null, type?: MeddiAccountType | null } | null> | null } | null };

export type UserOrdersQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type UserOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersResult', meta?: { __typename?: 'PageInfo', count?: number | null, page?: number | null, limit?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'Order', issueDate?: any | null, name?: string | null, paymentMethod?: OrderPaymentMethod | null, price?: { __typename?: 'TransactionPrice', formattedPrice?: string | null } | null, invoices?: Array<{ __typename?: 'Invoice', id?: any | null, url?: string | null, number?: string | null } | null> | null } | null> | null } | null };

export type WizardPreviewFileQueryVariables = Exact<{
  fileId?: InputMaybe<Scalars['UUID']>;
}>;


export type WizardPreviewFileQuery = { __typename?: 'Query', documentationFiles?: { __typename?: 'DocumentationFilesResult', data?: Array<{ __typename?: 'DocumentationFile', id: any, name?: string | null, userId?: any | null, folderId?: any | null, file?: { __typename?: 'File', id: any, extension?: string | null } | null } | null> | null } | null };

export type WorkplacesQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type WorkplacesQuery = { __typename?: 'Query', workplaces?: { __typename?: 'WorkplacesResult', meta?: { __typename?: 'PageInfo', page?: number | null, totalPages?: number | null } | null, data?: Array<{ __typename?: 'Workplace', id: string, name?: string | null } | null> | null } | null };


export const TermItemsDocument = `
    query TermItems($termType: String, $fullText: String, $filter: TermItemsFilter, $take: Int, $pagination: PaginationInput) {
  termItems(
    termType: $termType
    fulltext: $fullText
    filter: $filter
    take: $take
    pagination: $pagination
  ) {
    data {
      id
      termId
      name
      value
      value2
      value3
      data
    }
  }
}
    `;
export const FilterCaseContactsDocument = `
    query FilterCaseContacts($fulltext: String, $caseTypeCode: String, $roleKeys: [String], $take: Int = 20, $skip: Int) {
  filterCaseContacts(
    fulltext: $fulltext
    caseTypeCode: $caseTypeCode
    roleKeys: $roleKeys
    pagination: {take: $take, skip: $skip}
  ) {
    meta {
      page
      totalPages
    }
    data {
      userId
      workplaceMemberId
      workplaceId
      textRow1
      textRow2
      textRow3
      type
      iconUrl
      workplaceMemberUserRelation(type: PATIENT_DOCTOR) {
        id
        userId
        user {
          profile {
            fullName
          }
        }
      }
    }
  }
}
    `;
export const CaseCreateUsersDocument = `
    query CaseCreateUsers($userIds: [UUID!]!) {
  users(take: 999, ids: $userIds) {
    data {
      id
      profileImageUrl
      profile {
        firstName
        lastName
        fullName
      }
      isChild
    }
  }
}
    `;
export const DashboardMessagesDocument = `
    query DashboardMessages {
  dashboardMessages {
    id
    content
    type
    sender {
      user {
        profile {
          fullName
        }
        profileImageUrl
      }
    }
  }
}
    `;
export const ReadDashboardMessageDocument = `
    mutation ReadDashboardMessage($input: ReadDashboardMessageInput) {
  readDashboardMessage(input: $input) {
    id
  }
}
    `;
export const DocumentationFilesDocument = `
    query DocumentationFiles($fileIds: [UUID]) {
  documentationFiles(fileIds: $fileIds) {
    meta {
      page
      totalPages
    }
    data {
      id
      name
      extension
      displayName
      folderId
      hasThumb
      userId
      thumbUrl
      avResult
      createdAt
      file {
        id
        name
        extension
      }
      createdBy {
        id
        profile {
          fullName
        }
      }
      workplace {
        id
        name
      }
      fileTransfers {
        value
      }
    }
  }
}
    `;
export const CreateDrMaxPrescriptionReservationDocument = `
    mutation createDrMaxPrescriptionReservation($input: CreateDrMaxPrescriptionReservationInput) {
  createDrMaxPrescriptionReservation(input: $input) {
    incrementId
  }
}
    `;
export const GetDrMaxPickupPlacesDocument = `
    query getDrMaxPickupPlaces($prescriptionId: UUID, $search: String, $pagination: PaginationInput) {
  drmaxPickupPlaces(
    search: $search
    prescriptionId: $prescriptionId
    pagination: $pagination
  ) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      id
      name
      isOpen
      productsInStock {
        name
        inStock
      }
      distanceFormatted
      openingHours {
        date
        open
        nonstop
        hours {
          to
          from
          note
          open
        }
      }
    }
  }
}
    `;
export const GetDrMaxPrescriptionMedicamentsDocument = `
    query getDrMaxPrescriptionMedicaments($prescriptionId: UUID!, $drmaxPickupPlaceId: UUID, $pagination: PaginationInput) {
  drmaxPrescriptionMedicaments(
    prescriptionId: $prescriptionId
    pagination: $pagination
  ) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      name
      formattedApproximatePrice(drmaxPickupPlaceId: $drmaxPickupPlaceId)
      inStock(drmaxPickupPlaceId: $drmaxPickupPlaceId)
    }
  }
}
    `;
export const GetPrescriptionDocument = `
    query getPrescription($prescriptionId: UUID!) {
  prescription(id: $prescriptionId) {
    drMaxPickupPlace {
      openingHours {
        date
        open
        nonstop
        hours {
          to
          from
          note
          open
        }
      }
    }
  }
}
    `;
export const FamilyMemberRelationDocument = `
    mutation familyMemberRelation($input: FamilyMemberRelationInput) {
  familyMemberRelation(input: $input) {
    userId
  }
}
    `;
export const GetFamilyMemberShareListDocument = `
    query getFamilyMemberShareList($childId: UUID!) {
  familyMemberShareList(childId: $childId) {
    meta {
      count
    }
    data {
      userId
      user {
        profileImageUrl
        profile {
          fullName
        }
      }
      role
    }
  }
}
    `;
export const GetFamilyMembersDocument = `
    query getFamilyMembers($pagination: PaginationInput, $role: FamilyMemberRole) {
  familyMembers(pagination: $pagination, role: $role) {
    data {
      userId
      user {
        profileImageUrl
        profile {
          fullName
        }
      }
      role
    }
  }
}
    `;
export const UpdateUserConsentDocument = `
    mutation UpdateUserConsent($where: UserConsentsWhereInput, $data: UpdateUserConsentInput) {
  updateUserConsent(where: $where, data: $data) {
    id
  }
}
    `;
export const UserConsentsDocument = `
    query UserConsents($where: UserConsentsWhereInput, $take: Int = 20, $skip: Int) {
  userConsents(where: $where, pagination: {skip: $skip, take: $take}) {
    meta {
      page
      totalPages
    }
    data {
      id
      type
      userId
      name
      workplace {
        name
        address {
          fullAddress
        }
      }
      createdBy {
        profile {
          fullName
        }
      }
      createdAt
      confirmedAt
      canceledAt
      value
      documentationFile {
        id
        userId
        folderId
        name
        file {
          id
          extension
        }
      }
    }
  }
}
    `;
export const MeasurementHistoryDocument = `
    query MeasurementHistory($where: WizardResultsWhereInput, $take: Int = 20, $skip: Int) {
  wizardResults(where: $where, pagination: {skip: $skip, take: $take}) {
    meta {
      page
      totalPages
    }
    data {
      id
      createdAt
      wizardResultItems(
        where: {showSystemKeys: false}
        pagination: {order: {how: ASC, key: "key"}}
      ) {
        id
        key
        value
        formattedValue
        label
      }
    }
    settings
  }
}
    `;
export const RemoveMeasurementHistoryItemDocument = `
    mutation RemoveMeasurementHistoryItem($input: DeleteWizardResultInput!) {
  deleteWizardResult(input: $input) {
    status
  }
}
    `;
export const ReactivateExpiredSubscriptionDocument = `
    mutation reactivateExpiredSubscription($input: ReactivateSubscriptionInput) {
  reactivateExpiredSubscription(input: $input) {
    redirectUrl
  }
}
    `;
export const SubscriptionPaymentMethodDocument = `
    query subscriptionPaymentMethod($input: PaySubscriptionInput) {
  subscriptionPaymentMethods(subscriptionOrder: $input) {
    title
    icon
    type
  }
}
    `;
export const TryChargeExpiredSubscriptionDocument = `
    mutation tryChargeExpiredSubscription($input: ChargeSubscriptionInput) {
  tryChargeExpiredSubscription(input: $input) {
    success
    message
  }
}
    `;
export const UserExpiredSubscriptionsDocument = `
    query userExpiredSubscriptions($id: UUID) {
  user(id: $id) {
    expiredSubscriptions {
      id
      subscription {
        id
      }
      subscriptionPeriod {
        id
      }
    }
  }
}
    `;
export const UserSubscriptionCancelDocument = `
    mutation UserSubscriptionCancel($input: UserSubscriptionCancelInput) {
  userSubscriptionCancel(input: $input) {
    status
  }
}
    `;
export const FamilyMemberInvitationDetailDocument = `
    query familyMemberInvitationDetail($id: UUID) {
  user(id: $id) {
    profile {
      fullName
      birthDate
      birthNumber
      address {
        formattedFullAddress
      }
      insuranceCompanyTermItem {
        value
        value2
      }
    }
  }
}
    `;
export const FamilyMembersDocument = `
    query familyMembers {
  familyMembers(pagination: {take: 999}) {
    data {
      id
      user {
        id
        profileImageUrl
        profile {
          firstName
        }
        email
      }
      role
    }
  }
}
    `;
export const FamilyMemberDocument = `
    query familyMember($id: Int) {
  familyMember(where: {id: $id}) {
    canBeDeleted
    canBeShared
  }
}
    `;
export const SimpleUserDocument = `
    query simpleUser($id: UUID) {
  user(id: $id) {
    profileImageUrl
    profile {
      firstName
    }
  }
}
    `;
export const CreateRatingDocument = `
    mutation CreateRating($input: CreateRatingInput) {
  createRating(input: $input) {
    id
  }
}
    `;
export const ActivateRedeemCodeDocument = `
    mutation ActivateRedeemCode($input: ActivateUserSubscriptionByRedeemCode) {
  activateUserSubscriptionByRedeemCode(input: $input) {
    id
  }
}
    `;
export const MeddiAccountTransactionsDocument = `
    query MeddiAccountTransactions($where: MeddiAccountTransactionsWhereInput, $pagination: PaginationInput) {
  meddiAccountTransactions(where: $where, pagination: $pagination) {
    data {
      id
      type
      amount
      orderId
      order {
        id
        issueDate
        status
        items {
          title
          unit
          quantity
        }
      }
    }
    meta {
      count
      page
      limit
      totalPages
    }
  }
}
    `;
export const MeddiAccountsDocument = `
    query MeddiAccounts($where: MeddiAccountsWhereInput) {
  meddiAccounts(where: $where) {
    data {
      balance
      type
    }
  }
}
    `;
export const UserOrdersDocument = `
    query userOrders($userId: UUID, $skip: Int, $take: Int = 20) {
  orders(
    filter: {orderMembers: [$userId]}
    pagination: {skip: $skip, take: $take}
  ) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      issueDate
      name
      price {
        formattedPrice
      }
      paymentMethod
      invoices {
        id
        url
        number
      }
    }
  }
}
    `;
export const WizardPreviewFileDocument = `
    query WizardPreviewFile($fileId: UUID) {
  documentationFiles(fileIds: [$fileId]) {
    data {
      id
      name
      userId
      folderId
      file {
        id
        extension
      }
    }
  }
}
    `;
export const WorkplacesDocument = `
    query Workplaces($fulltext: String, $patientId: UUID, $type: String, $take: Int = 20, $skip: Int) {
  workplaces(
    fulltext: $fulltext
    patientId: $patientId
    type: $type
    pagination: {take: $take, skip: $skip}
  ) {
    meta {
      page
      totalPages
    }
    data {
      id
      name
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    TermItems: build.query<TermItemsQuery, TermItemsQueryVariables | void>({
      query: (variables) => ({ document: TermItemsDocument, variables })
    }),
    FilterCaseContacts: build.query<FilterCaseContactsQuery, FilterCaseContactsQueryVariables | void>({
      query: (variables) => ({ document: FilterCaseContactsDocument, variables })
    }),
    CaseCreateUsers: build.query<CaseCreateUsersQuery, CaseCreateUsersQueryVariables>({
      query: (variables) => ({ document: CaseCreateUsersDocument, variables })
    }),
    DashboardMessages: build.query<DashboardMessagesQuery, DashboardMessagesQueryVariables | void>({
      query: (variables) => ({ document: DashboardMessagesDocument, variables })
    }),
    ReadDashboardMessage: build.mutation<ReadDashboardMessageMutation, ReadDashboardMessageMutationVariables | void>({
      query: (variables) => ({ document: ReadDashboardMessageDocument, variables })
    }),
    DocumentationFiles: build.query<DocumentationFilesQuery, DocumentationFilesQueryVariables | void>({
      query: (variables) => ({ document: DocumentationFilesDocument, variables })
    }),
    createDrMaxPrescriptionReservation: build.mutation<CreateDrMaxPrescriptionReservationMutation, CreateDrMaxPrescriptionReservationMutationVariables | void>({
      query: (variables) => ({ document: CreateDrMaxPrescriptionReservationDocument, variables })
    }),
    getDrMaxPickupPlaces: build.query<GetDrMaxPickupPlacesQuery, GetDrMaxPickupPlacesQueryVariables | void>({
      query: (variables) => ({ document: GetDrMaxPickupPlacesDocument, variables })
    }),
    getDrMaxPrescriptionMedicaments: build.query<GetDrMaxPrescriptionMedicamentsQuery, GetDrMaxPrescriptionMedicamentsQueryVariables>({
      query: (variables) => ({ document: GetDrMaxPrescriptionMedicamentsDocument, variables })
    }),
    getPrescription: build.query<GetPrescriptionQuery, GetPrescriptionQueryVariables>({
      query: (variables) => ({ document: GetPrescriptionDocument, variables })
    }),
    familyMemberRelation: build.mutation<FamilyMemberRelationMutation, FamilyMemberRelationMutationVariables | void>({
      query: (variables) => ({ document: FamilyMemberRelationDocument, variables })
    }),
    getFamilyMemberShareList: build.query<GetFamilyMemberShareListQuery, GetFamilyMemberShareListQueryVariables>({
      query: (variables) => ({ document: GetFamilyMemberShareListDocument, variables })
    }),
    getFamilyMembers: build.query<GetFamilyMembersQuery, GetFamilyMembersQueryVariables | void>({
      query: (variables) => ({ document: GetFamilyMembersDocument, variables })
    }),
    UpdateUserConsent: build.mutation<UpdateUserConsentMutation, UpdateUserConsentMutationVariables | void>({
      query: (variables) => ({ document: UpdateUserConsentDocument, variables })
    }),
    UserConsents: build.query<UserConsentsQuery, UserConsentsQueryVariables | void>({
      query: (variables) => ({ document: UserConsentsDocument, variables })
    }),
    MeasurementHistory: build.query<MeasurementHistoryQuery, MeasurementHistoryQueryVariables | void>({
      query: (variables) => ({ document: MeasurementHistoryDocument, variables })
    }),
    RemoveMeasurementHistoryItem: build.mutation<RemoveMeasurementHistoryItemMutation, RemoveMeasurementHistoryItemMutationVariables>({
      query: (variables) => ({ document: RemoveMeasurementHistoryItemDocument, variables })
    }),
    reactivateExpiredSubscription: build.mutation<ReactivateExpiredSubscriptionMutation, ReactivateExpiredSubscriptionMutationVariables | void>({
      query: (variables) => ({ document: ReactivateExpiredSubscriptionDocument, variables })
    }),
    subscriptionPaymentMethod: build.query<SubscriptionPaymentMethodQuery, SubscriptionPaymentMethodQueryVariables | void>({
      query: (variables) => ({ document: SubscriptionPaymentMethodDocument, variables })
    }),
    tryChargeExpiredSubscription: build.mutation<TryChargeExpiredSubscriptionMutation, TryChargeExpiredSubscriptionMutationVariables | void>({
      query: (variables) => ({ document: TryChargeExpiredSubscriptionDocument, variables })
    }),
    userExpiredSubscriptions: build.query<UserExpiredSubscriptionsQuery, UserExpiredSubscriptionsQueryVariables | void>({
      query: (variables) => ({ document: UserExpiredSubscriptionsDocument, variables })
    }),
    UserSubscriptionCancel: build.mutation<UserSubscriptionCancelMutation, UserSubscriptionCancelMutationVariables | void>({
      query: (variables) => ({ document: UserSubscriptionCancelDocument, variables })
    }),
    familyMemberInvitationDetail: build.query<FamilyMemberInvitationDetailQuery, FamilyMemberInvitationDetailQueryVariables | void>({
      query: (variables) => ({ document: FamilyMemberInvitationDetailDocument, variables })
    }),
    familyMembers: build.query<FamilyMembersQuery, FamilyMembersQueryVariables | void>({
      query: (variables) => ({ document: FamilyMembersDocument, variables })
    }),
    familyMember: build.query<FamilyMemberQuery, FamilyMemberQueryVariables | void>({
      query: (variables) => ({ document: FamilyMemberDocument, variables })
    }),
    simpleUser: build.query<SimpleUserQuery, SimpleUserQueryVariables | void>({
      query: (variables) => ({ document: SimpleUserDocument, variables })
    }),
    CreateRating: build.mutation<CreateRatingMutation, CreateRatingMutationVariables | void>({
      query: (variables) => ({ document: CreateRatingDocument, variables })
    }),
    ActivateRedeemCode: build.mutation<ActivateRedeemCodeMutation, ActivateRedeemCodeMutationVariables | void>({
      query: (variables) => ({ document: ActivateRedeemCodeDocument, variables })
    }),
    MeddiAccountTransactions: build.query<MeddiAccountTransactionsQuery, MeddiAccountTransactionsQueryVariables | void>({
      query: (variables) => ({ document: MeddiAccountTransactionsDocument, variables })
    }),
    MeddiAccounts: build.query<MeddiAccountsQuery, MeddiAccountsQueryVariables | void>({
      query: (variables) => ({ document: MeddiAccountsDocument, variables })
    }),
    userOrders: build.query<UserOrdersQuery, UserOrdersQueryVariables | void>({
      query: (variables) => ({ document: UserOrdersDocument, variables })
    }),
    WizardPreviewFile: build.query<WizardPreviewFileQuery, WizardPreviewFileQueryVariables | void>({
      query: (variables) => ({ document: WizardPreviewFileDocument, variables })
    }),
    Workplaces: build.query<WorkplacesQuery, WorkplacesQueryVariables | void>({
      query: (variables) => ({ document: WorkplacesDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useTermItemsQuery, useLazyTermItemsQuery, useFilterCaseContactsQuery, useLazyFilterCaseContactsQuery, useCaseCreateUsersQuery, useLazyCaseCreateUsersQuery, useDashboardMessagesQuery, useLazyDashboardMessagesQuery, useReadDashboardMessageMutation, useDocumentationFilesQuery, useLazyDocumentationFilesQuery, useCreateDrMaxPrescriptionReservationMutation, useGetDrMaxPickupPlacesQuery, useLazyGetDrMaxPickupPlacesQuery, useGetDrMaxPrescriptionMedicamentsQuery, useLazyGetDrMaxPrescriptionMedicamentsQuery, useGetPrescriptionQuery, useLazyGetPrescriptionQuery, useFamilyMemberRelationMutation, useGetFamilyMemberShareListQuery, useLazyGetFamilyMemberShareListQuery, useGetFamilyMembersQuery, useLazyGetFamilyMembersQuery, useUpdateUserConsentMutation, useUserConsentsQuery, useLazyUserConsentsQuery, useMeasurementHistoryQuery, useLazyMeasurementHistoryQuery, useRemoveMeasurementHistoryItemMutation, useReactivateExpiredSubscriptionMutation, useSubscriptionPaymentMethodQuery, useLazySubscriptionPaymentMethodQuery, useTryChargeExpiredSubscriptionMutation, useUserExpiredSubscriptionsQuery, useLazyUserExpiredSubscriptionsQuery, useUserSubscriptionCancelMutation, useFamilyMemberInvitationDetailQuery, useLazyFamilyMemberInvitationDetailQuery, useFamilyMembersQuery, useLazyFamilyMembersQuery, useFamilyMemberQuery, useLazyFamilyMemberQuery, useSimpleUserQuery, useLazySimpleUserQuery, useCreateRatingMutation, useActivateRedeemCodeMutation, useMeddiAccountTransactionsQuery, useLazyMeddiAccountTransactionsQuery, useMeddiAccountsQuery, useLazyMeddiAccountsQuery, useUserOrdersQuery, useLazyUserOrdersQuery, useWizardPreviewFileQuery, useLazyWizardPreviewFileQuery, useWorkplacesQuery, useLazyWorkplacesQuery } = injectedRtkApi;

